import Vue from "vue"
import $ from "jquery";
import AjaxUtils from "../../util/ajax_utils";
import Store from "../../data/store";
import {
    ApckVulnBulkAssigneeForm,
    ApckVulnBulkNotesForm,
    ApckVulnBulkPriorityForm,
    ApckVulnBulkStatusForm,
} from "./bulk-edit-forms";
import {ApckVulnerability} from "./vulnerability";
import {ApckColumnActions, ApckTooltipBase} from "../form";
import {ApckAccordion} from "../common/accordion";

import {ApckGlFilteredSearch} from '../filtered_search/apck_glfiltered_search';
import {ApckGlFilteredSearchToken} from "../filtered_search/apck_glfiltered_search_token";
import {parseGitlabFilters, reconstructGitlabFilters} from "../../util/gitlab_filters";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import get from 'lodash/get';
import set from 'lodash/set';
import isEqual from 'lodash/isEqual';
import {getWindowDimensions} from "../../util/helpers";
import {COLOR_TO_TYPE} from "../_ui/_utils/useValidationUtils";
import VulnDetails from "./details/VulnDetails.vue";


const deleteVulnerabilities = function ({cmp, url, data = {}, success_cb = undefined}) {
    AjaxUtils.ajax_post({
        url: url,
        data: JSON.stringify(data),
        success: function (data) {
            const count = data.count || 0;
            if (count === 0) {
                cmp.$flash({
                    type: 'error',
                    message: `No vulnerabilities found`,
                })
            } else if (data.count === 1) {
                cmp.$flash({
                    type: 'success',
                    message: 'Vulnerability deleted successfully',
                });
            } else {
                cmp.$flash({
                    type: 'success',
                    message: `${count} vulnerabilities have been deleted successfully`
                })
            }
            if (typeof success_cb === "function" ) {
                success_cb(data);
            }
        }, fail: function () {

        }
    });
};


const ApckVulnSearchSaveModal = {
    props: {
        url: String,
        table: {
            type: Object,
            default: () => ({}),
        },
        serializedFilters: {
            type: Object,
            default: () => ({}),
        },
        errors: {
            type: Object,
            default: () => ({}),
        }
    },
    data: function () {
        return {
            name: null,
            loading: false,
            errorsKey: 0,
        };
    },
    mounted() {
        this.$refs.input.$refs.field.focus();
    },
    methods: {
        save: function () {
            var cmp = this;
            if (!cmp.name) {
                cmp.$flash({type: 'error', message: `Please enter a name for the saved filters`})
                return;
            }
            cmp.loaded = false;

            cmp.$emit('updateErrors', {});
            cmp.errorsKey += 1;

            const data = {
                'name': cmp.name,
                'filters': cmp.serializedFilters,
            };
            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(data),
                success: function (json, status, xhr) {
                    cmp.loaded = true;
                    cmp.$emit('close');
                    cmp.$emit('saved', cmp.name);
                },
                fail: function (json, status, xhr) {
                    cmp.$emit('updateErrors', json?.field_errors ? json.field_errors : {});
                    cmp.errorsKey += 1;
                    cmp.loaded = true;
                }
            });
        },
    },
    template: `
        <div class="vuln-table-lightbox"> 
            <div class="vuln-lightbox-title-bar">
                <span class="title">Save vulnerability search filters</span>
            </div> 
            <div class="vuln-lightbox-inner">
        
                <div :key="errorsKey">
                    <apck-field :errors="errors?.name">
                        <apck-text
                            v-model="name"
                            ref="input"
                            tabindex="0"
                            autofocus
                            label="Name"
                            @enter-pressed="save"
                        />
                    </apck-field>
                    
                    <apck-mask :trigger="loading" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
                </div>
                
            </div>
            <div class="vuln-lightbox-actions">
                <apck-button
                    icon=""
                    class="btn-muted"
                    tabindex="0"
                    :handler="() => $emit('close')"
                    title="Close"
                    value="Close"
                />
                <apck-button
                    icon=""
                    class="btn-primary"
                    tabindex="0"
                    :handler="save"
                    title="Save"
                    value="Save"
                />
            </div>
        </div>
    `
};

const ApckVulnSearchSelectModal = {
    props: {
        url: String,
        table: Object,
    },
    data: function () {
        return {
            nameSearch: '',
            savedSearches: [],
            filteredSearches: [],
            count: 0,
            loading: false,
            selectedItem: null
        };
    },
    mounted: function () {
        const cmp = this;
        this.$refs.input.focus();
        cmp.loading = true;

        AjaxUtils.ajax_get({
            url: cmp.url,
            success: function (data) {
                if (data) {
                    cmp.$data.savedSearches = data.saved_searches;
                    cmp.$data.filteredSearches = data.saved_searches;
                    cmp.$data.count = data.count;
                }
                cmp.loading = false;
            },
            fail: function () {
                cmp.loading = false;
            },
            opts: {err_404_message: 'Could not load saved searches'}
        });
    },
    watch: {
        nameSearch(value) {
            this.search(value);
        },
        savedSearches() {
            this.search(this.nameSearch);
        }
    },
    methods: {
        search(term) {
            if (term) {
                this.filteredSearches = this.savedSearches.filter(
                    option => option.name.toLowerCase().includes(term.toLowerCase())
                );
            } else {
                this.filteredSearches = this.savedSearches;
            }
        },
        select(item) {
            this.selectedItem = item;
        },
        load() {
            var cmp = this;
            const item = cmp.selectedItem;
            if (item === null) {
                cmp.$flash({type: 'error', message: 'Please select a saved filter.'});
                return;
            }

            cmp.loaded = false;

            AjaxUtils.ajax_get({
                url: `${this.url}/${item._id}`,
                success: function (json, status, xhr) {
                    cmp.loaded = true;
                    if (!Object.keys(json.filters)) {
                        cmp.$flash({message: 'Failed to load filters.', type: 'error'});
                        cmp.$emit('close');
                        return;
                    }
                    cmp.$flash({message: 'Successfully loaded search filters.'});
                    cmp.$emit('loadedFilters', json.filters, item.name);
                    cmp.$emit('close');
                },
                fail: function (json, status, xhr) {
                    cmp.loaded = true;
                }
            });
        },
        deleteSearch(item) {
            var cmp = this;
            cmp.loaded = false;

            cmp.$dialog.confirm(
                `Are you sure you want to delete '${item.name}'?`,
                'Delete',
                function () {
                    AjaxUtils.ajax_post({
                        url: `${cmp.url}/${item._id}/delete`,
                        success: function (json, status, xhr) {
                            cmp.loaded = true;
                            cmp.savedSearches = cmp.savedSearches.filter((n) => n._id !== item._id);
                        },
                        fail: function (json, status, xhr) {
                            cmp.loaded = true;
                        }
                    });
                }
            );
        }
    },
    template: `
        <div class="vuln-table-lightbox"> 
            <div class="vuln-lightbox-title-bar">
                <span class="title">Load vulnerability search filters</span>
            </div> 
            <div class="vuln-lightbox-inner">
                    
                <div class="vuln-saved-searches">
                    <apck-field v-if="savedSearches">
                        <input
                            ref="input"
                            v-model="nameSearch"
                            tabindex="0"
                            autofocus
                            placeholder="Search..."
                        />
                    </apck-field>
                    
                    <div class="form-field"><div class="label">Saved Filters</div></div>
                    <ul class="search-list">
                        <template v-if="filteredSearches.length">
                            <li
                                v-for="item in filteredSearches"
                            >
                                <div class="search-list-title"
                                     tabindex="0"
                                     @click="select(item)"
                                     @keyup.space="select(item)"
                                >
                                    <div class="radio-btn">
                                        <i v-if="selectedItem && item._id === selectedItem._id" class="fa-regular fa-circle-dot"></i>
                                        <i v-else class="fa-regular fa-circle"></i>
                                    </div>
                                    <span>{{ item.name }}</span>
                                </div>
                                
                                <apck-button
                                    icon="fa-regular fa-trash-can"
                                    class="btn-muted"
                                    tabindex="0"
                                    :handler="() => deleteSearch(item)"
                                    title="Delete saved search filters"
                                />
                            </li>
                        </template>
                        <li v-else>No saved searches found</li>
                    </ul>
                    
                    <apck-mask :trigger="loading" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
                </div>
                
            </div>
            <div class="vuln-lightbox-actions">
                <apck-button
                    icon=""
                    class="btn-muted"
                    tabindex="0"
                    :handler="() => $emit('close')"
                    title="Close"
                    value="Close"
                />
                <apck-button
                    icon=""
                    class="btn-primary"
                    tabindex="0"
                    :handler="load"
                    title="Load filters"
                    value="Load filters"
                />
            </div>
        </div>
    `
};


const ApckVulnFilters = {
    props: {
        table: Object,
    },
    data: function () {
        return {
            assignee_id: '',
            status: '',
            host: [],
            first_detected_start: '',
            first_detected_end: '',
            last_detected_start: '',
            last_detected_end: '',
        };
    },
    mounted: function () {
        const cmp = this;
        cmp.assignee_id = cmp.table.query.assignee_id;
        cmp.status = cmp.table.query.status;
        cmp.host = cmp.table.query.host;
        cmp.first_detected_start = cmp.table.query.first_detected_start;
        cmp.first_detected_end = cmp.table.query.first_detected_end;
        cmp.last_detected_start = cmp.table.query.last_detected_start;
        cmp.last_detected_end = cmp.table.query.last_detected_end;

        this.$refs.lightbox.focus();
    },
    methods: {
        apply() {
            const cmp = this;
            cmp.table.query.assignee_id = cmp.assignee_id;
            cmp.table.query.status = cmp.status;
            cmp.table.query.host = cmp.host;
            cmp.table.query.first_detected_start = cmp.first_detected_start;
            cmp.table.query.first_detected_end = cmp.first_detected_end;
            cmp.table.query.last_detected_start = cmp.last_detected_start;
            cmp.table.query.last_detected_end = cmp.last_detected_end;
            cmp.$emit('close');
        },
    },
    computed: {
        first_detected_start_from() {
            const d = this.first_detected_end || this.last_detected_start || this.last_detected_end;
            return d === '' ? new Date() : new Date();
        },
        first_detected_end_to() {
            return this.first_detected_start === '' ? null : new Date(this.first_detected_start);
        },
        first_detected_end_from() {
            const d = this.last_detected_start || this.last_detected_end;
            return d === '' ? new Date() : new Date(d);
        },
        last_detected_start_to() {
            const d = this.first_detected_end || this.first_detected_start;
            return d === '' ? null : new Date(d);
        },
        last_detected_start_from() {
            return this.last_detected_end === '' ? new Date() : new Date(this.last_detected_end);
        },
        last_detected_end_to() {
            const d = this.last_detected_start || this.first_detected_end || this.first_detected_start;
            return d === '' ? null : new Date(d);
        },
    },
    template: `
        <div class="vuln-table-lightbox" tabindex="-1" ref="lightbox"> 
            <div class="vuln-lightbox-title-bar">
                <span class="title">Filters</span>
                <apck-button
                    icon="fa-regular fa-floppy-disk"
                    class="btn-secondary"
                    tabindex="0"
                    :handler="() => {table.saveSearch($data);}"
                    title="Save Filter"
                    value="Save Filter"
                />
            </div> 
            <div class="vuln-lightbox-inner">
                
                <div class="vuln-new-filters">
                    <apck-field v-if="table.showUserFilter">
                        <span>Assigned User</span>
                        <apck-select
                            v-model="assignee_id"
                            :options="table.assignee_options"
                            searchable
                            defaultValue="all"
                            :showLabel="false"
                            :vulnFilterSelect="true"
                            :useBrowserSelect="true"
                        />
                    </apck-field>
                    
                    <apck-field>
                        <span>Status</span>
                        <apck-select
                            v-model="status"
                            :options="table.status_options"
                            :defaultValue="['all']"
                            multiple
                            multipleAllValue="all"
                            :showLabel="false"
                            :vulnFilterSelect="true"
                            :useBrowserSelect="false"
                            :multipleSelectTransformer="(current, value) => !current.size ? new Set(['all']) : current"
                        />
                    </apck-field>
                
                    <apck-field v-if="table.showHostFilter">
                        <span>Hosts</span>
                        <apck-select
                            v-model="host"
                            :options="table.host_options"
                            :defaultValue="['all']"
                            multiple
                            multipleAllValue="all"
                            searchable
                            :showLabel="false"
                            :vulnFilterSelect="true"
                            :useBrowserSelect="false"
                            :multipleSelectTransformer="(current, value) => !current.size ? new Set(['all']) : current"
                        />
                    </apck-field>
                    
                    <apck-field v-if="table.showDateFilters">
                        <span>Date First Detected</span>
                        <apck-filter-date-range
                            ref="first_detected"
                            :showLabel="false"
                            format="yyyy-MM-dd"
                            :from="first_detected_start"
                            :to="first_detected_end"
                            @fromUpdated="(value) => {first_detected_start = value}"
                            @toUpdated="(value) => {first_detected_end = value}"
                            :fromDisabledDates="{'from': first_detected_start_from}"
                            :toDisabledDates="{'to': first_detected_end_to, 'from': first_detected_end_from}"
                        />
                    </apck-field>
                    
                    <apck-field v-if="table.showDateFilters">
                        <span>Date Last Detected</span>
                        <apck-filter-date-range
                            ref="last_detected"
                            :showLabel="false"
                            format="yyyy-MM-dd"
                            :from="last_detected_start"
                            :to="last_detected_end"
                            @fromUpdated="(value) => {last_detected_start = value}"
                            @toUpdated="(value) => {last_detected_end = value}"
                            :fromDisabledDates="{'to': last_detected_start_to, 'from': last_detected_start_from}"
                            :toDisabledDates="{'to': last_detected_end_to, 'from': new Date()}"
                        />
                    </apck-field>
                </div>
            </div>
            <div class="vuln-lightbox-actions">
                <apck-button
                    icon=""
                    class="btn-muted"
                    :handler="() => $emit('close')"
                    title="Close"
                    value="Close"
                />
                <apck-button
                    icon=""
                    class="btn-primary"
                    :handler="apply"
                    title="Apply"
                    value="Apply"
                />
            </div>
        </div>
    `
};


const ApckCvssCol = {
    props: {
        cvss_v2: {
            type: [Number, String],
            default: '-'
        },
        cvss_v3: {
            type: [Number, String],
            default: '-'
        },
        impact: {
            type: String,
            default: null
        }
    },
    template: `
        <div class="cell">
            <div class="cell-value cvss-cell">
              <i :class="['fa', 'fa-circle', 'icon', 'severity-icon-' + impact]"></i>
              
              <span title="CVSS V2 score">{{ cvss_v2 || '-' }}</span>
              / <span title="CVSS V3 score">{{ cvss_v3 || '-' }}</span>  
            </div>
        </div>
    `
}

const ApckVulnDetailsRollout = {
    components: {
        'vuln-details': VulnDetails,
    },
    props: {
        _ids: {
            type: Array,
            default: () => [],
        },
        initial_id: {
            type: String,

        }
    },
    data: function () {
        return {
            current_page: 0
        };
    },
    computed: {
        current_id () {
            return this._ids[this.current_page];
        }
    },
    mounted() {
        const index = this._ids.findIndex(el => el === this.initial_id);
        this.current_page = index > -1 ? index : 0;
        this.updateTitle()
    },
    watch: {
        '$route.path': function(val) {
            this.$emit('close');
        },
    },
    methods: {
        previous() {
            if (this.current_page > 0) {
                this.current_page--;

                this.updateTitle()
            }
        },
        next() {
            if (this.current_page + 1 < this._ids.length) {
                this.current_page++;

                this.updateTitle()
            }
        },
        updateTitle() {
            this.$emit('update:modal-title', `Vulnerability Details (${this.current_page + 1 }/${this._ids.length})`)

            this.$emit('update:modal-header-button', {
                key: 'previous',
                disabled: this.current_page === 0
            })

            this.$emit('update:modal-header-button', {
                key: 'next',
                disabled: this.current_page + 1 >= this._ids.length
            })
        }
    },
    template: `
        <transition name="short-slide-up" mode="out-in">
            <vuln-details
                :key="current_id"
                :_id="current_id"
                @workflow-updated="$emit('workflow-updated')"
                @router.changed="$emit('close')"
            />
        </transition>
    `
}

function sanitiseFilename(filename) {
    // Replace things that Windows explorer can't deal with, even though the
    // underlying NTFS would have no problem actually storing files with these names.
    // Linux (and probably OSX because it's also UNIXy) doesn't like '/' and 0.
    const evilCharacters = " \\/:*?\"<>|";

    return Array.from(filename).map(c => {
        const charCode = c.charCodeAt(0);
        if (charCode >= 32 && charCode < 128 && !evilCharacters.includes(c)) {
            return c;
        } else {
            return "_";
        }
    }).join("");
}

const ApckVulnReportRollout = {
    props: {
        table: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            reports: [{
            //     id: 'generatePdfReport',
            //     title: 'PDF Report',
            //     type: 'pdf',
            //     icon: 'fa-file-pdf',
            //     description: 'Generate a PDF report of the filtered vulnerabilities.',
            // }, {
                id: 'generateWordReport',
                title: 'Word Report',
                type: 'docx',
                icon: 'fa-file-word',
                description: 'Generate a Word (.docx) report of the filtered, unresolved vulnerabilities.',
            }, {
                id: 'generateExcelReport',
                title: 'Excel Report',
                type: 'xlsx',
                icon: 'fa-file-excel',
                description: 'Generate a Excel (.xlsx) report of the filtered vulnerabilities.',
            }, {
                id: 'generateExecReport',
                title: 'Exec Report',
                type: 'exec_pdf',
                icon: 'fa-file-pdf',
                description: 'Generate an executive summary report (.pdf) of the filtered vulnerabilities.',
            }, {
                id: 'generateJsonReport',
                title: 'JSON Export',
                type: 'json',
                icon: 'fa-download',
                description: 'Export the filtered vulnerabilities as JSON.',
            }],
        }
    },
    methods: {
        updateProgress(val) {
            const updatedProgress = Object.assign({}, this.table.reportGenerationProgress, val);
            Vue.set(this.table, 'reportGenerationProgress', updatedProgress);
        },
        generateReport(reportConf) {
            if (this.table.reportGenerationProgress.status && ['starting', 'ongoing'].includes(this.table.reportGenerationProgress.status)) {
                this.$flash({ message: 'A report is already being generated.', type: 'error' });
                return;
            }

            const cmp = this;
            const format = reportConf.type;
            const title = reportConf.title;

            let params = cmp.table.buildQueryParams();
            if(cmp.table.results_set_ids !== null) {
                params['results_set_ids'] = cmp.table.results_set_ids;
            }

            let url = `/vulnerabilities/report/${format}`;
            if (format === 'json') {
                cmp.$dialog.confirm(
                    'Export the filtered vulnerabilities as JSON?',
                    'Generate report',
                    function () {
                        cmp.$flash({message: 'Generating report...'});
                        cmp.updateProgress({
                            status: 'starting',
                            download_link: null,
                            title: title,
                            format: format,
                        });

                        AjaxUtils.ajax_post({
                            url: url,
                            data: JSON.stringify(params),
                            dataType: 'json',
                            success: function (json) {
                                const banner = json.banner ? json.banner : "CONFIDENTIAL";
                                if (json.items) {
                                    let fileUrl = URL.createObjectURL(
                                        new Blob([JSON.stringify(json)],
                                            {type: 'application/json'}
                                        ));
                                    let reportName = cmp.table.scan_name ? `${cmp.table.scan_name}_JSON_Export_${banner}` : `JSON_Export_${banner}`;
                                    reportName = sanitiseFilename(`${reportName}_${cmp.table.formatDate(new Date())}`);
                                    const anchor = document.createElement('a');
                                    anchor.href = fileUrl;
                                    anchor.download = `${reportName}.json`;
                                    anchor.click();
                                    cmp.updateProgress({
                                        status: 'success',
                                        download_link: fileUrl,
                                        filename: reportName,
                                        title: title
                                    });
                                    cmp.completed();
                                }
                            },
                            fail: function () {
                                cmp.$flash({message: 'JSON generation failed.', type: 'error'});
                                cmp.updateProgress({
                                    status: 'failed',
                                });
                            }
                        });
                    });
                return;
            }

            cmp.$dialog.confirm(
                `Generate a ${format} report of the filtered vulnerabilities?`,
                'Generate report',
                function () {
                    cmp.$flash({message: 'Generating report...'});
                    cmp.updateProgress({
                        status: 'starting',
                        download_link: null,
                        title: title,
                        format: format,
                    });

                    const errorFlash = (errorMessage='', status=null, xhr=null) => {
                        if (!errorMessage) {
                            if (status === 504) {
                                errorMessage = 'The server cannot process your request at the moment.' +
                                    ' Please try again later.';
                            } else if (xhr && xhr.responseText.indexOf('NO_SUITABLE_CLIENT_FOUND') >= 0) {
                                errorMessage = "The server cannot process your request at the moment " +
                                    "because there are no workers available. Please try again later.";
                            } else {
                                errorMessage = 'Report generation failed.';
                            }
                        }
                        cmp.$flash({message: errorMessage, type: 'error'});
                        cmp.updateProgress({
                            status: 'failed',
                        });
                    }

                    AjaxUtils.ajax_post({
                        url: url,
                        data: JSON.stringify(params),
                        dataType: 'json',
                        success: function (json, status, xhr) {
                            if (json.poll_url) {
                                cmp.startPolling(json.poll_url, errorFlash);
                            }
                            else if (json.status === 'completed') {
                                let download_link = `${json.download_link}?format=${cmp.table.reportGenerationProgress.format}`;
                                if (cmp.table.scan_name) {
                                    download_link += `&scan_name=${encodeURIComponent(cmp.table.scan_name)}`;
                                }
                                window.location = download_link;
                                cmp.updateProgress({
                                    status: 'success',
                                    download_link: download_link,
                                    filename: json.filename,
                                });
                                cmp.onComplete();
                            }
                            else if (json.status === 'failed') {
                                errorFlash(json?.message);
                            }
                        },
                        fail: function (json, status, xhr) {
                            errorFlash(json?.message, status, xhr);
                        }
                    });
                }
            );
        },
        startPolling(poll_url, errorHandler) {
            const cmp = this;
            setTimeout((function pollReport() {
                AjaxUtils.ajax_get({
                    url: poll_url,
                    success: function (json) {
                        if (json.status === 'ongoing') {
                            cmp.updateProgress({
                                status: 'ongoing',
                            });
                            setTimeout(pollReport, 2000);
                        } else if (json.status === 'completed') {
                            let download_link = `${json.download_link}?format=${cmp.table.reportGenerationProgress.format}`;
                            if (cmp.table.scan_name) {
                                download_link += `&scan_name=${encodeURIComponent(cmp.table.scan_name)}`;
                            }
                            window.location = download_link;
                            cmp.updateProgress({
                                status: 'success',
                                download_link: download_link,
                                filename: json.filename,
                            });
                            cmp.onComplete();
                        } else if (json.status === 'failed') {
                            errorHandler(json?.message);
                        }
                    },
                    fail: function (json, status, xhr) {
                        let errorMessage = json?.message;
                        if (!errorMessage) {
                            if (status === 504) {
                                errorMessage = 'The server cannot process your request at the moment.' +
                                    ' Please try again later.';
                            } else {
                                errorMessage = 'Report generation failed.';
                            }
                        }
                        cmp.$flash({message: errorMessage, type: 'error'});
                        cmp.updateProgress({
                            status: 'failed',
                        });
                    }
                });
            }), 200);
        },
        onComplete() {
            this.completed = true;
        }
    },
    template: `
        <div class="vuln-report-rollout">
            <div class="vuln-detail-rollout-header">
                <span>Vulnerabilities Report</span>
                <div class="btn-group">
                    <apck-button
                        title="Close"
                        icon="fa-times"
                        class="btn-primary"
                        :handler="() => $emit('close')"
                    />
                </div>
            </div>
            
            <div class="vuln-detail-rollout-body">
                <div class="goscript-tpl">
                    <div class="goscript-tpl__container">
                        <div 
                            v-for="(item, index) in reports"
                            :key="index"
                            :id="item.id"
                            class="goscript-tpl__item"
                            @click="generateReport(item)"
                        >
                            <i :class="['fa-regular', item.icon, 'goscript-tpl__icon']"></i>
                            <div class="goscript-tpl__content">
                                <div class="goscript-tpl__title">{{ item.title }}</div>
                                <div class="goscript-tpl__description">{{ item.description }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="table.reportGenerationProgress.status" class="vuln-report-progress">
                    <h2>Generating {{table.reportGenerationProgress.title}}</h2>
                    <p>
                        Status: {{table.reportGenerationProgress.status}}
                        <i
                            v-if="['ongoing', 'starting'].includes(table.reportGenerationProgress.status)"
                            class="fa fa-spinner fa-spin"
                        />
                    </p>
                
                    <p v-if="table.reportGenerationProgress.status === 'downloaded'">
                        Your file has been downloaded
                    </p>
                    <template v-else-if="table.reportGenerationProgress.download_link">
                        <p>
                            Your file is ready. It should download automatically, but you can
                            click the download button if it does not.
                        </p>
                        <a
                            v-if="table.reportGenerationProgress.download_link"
                            class="btn btn-primary"
                            :href="table.reportGenerationProgress.download_link"
                            :download="table.reportGenerationProgress.filename + '.' + table.reportGenerationProgress.format"
                            @click="table.reportGenerationProgress.status = 'downloaded'"
                        >
                            <i class="fa fa-download"/>
                            <span>Download</span>
                        </a>
                    </template>
                    
                </div>
            </div>
        </div>
    `
}

const ApckVulnImportModal = {
    components: {
        'apck-accordion': ApckAccordion
    },
    data: function () {
        return {
            results_set: null,
            results_set_options: [],
            file: null,
            loading: false,
            errorsKey: 0,
        };
    },
    props: {
        url: String,
        loaded_results_sets: {
            type: Array,
            default: () => []
        },
        errors: {
            type: Object,
            default: () => ({}),
        }
    },
    mounted: function () {
        const cmp = this;
        cmp.loading = true;
        const params = {'results_set_ids': cmp.loaded_results_sets};
        AjaxUtils.ajax_get({
            url: cmp.url,
            query_params: params,
            traditional: true,
            success: function (data) {
                if (data) {
                    cmp.$data.results_set_options = data.results_set_options;
                    cmp.results_set = data.results_set_options[0].value;
                }
                cmp.loading = false;
            },
            fail: function () {
                cmp.loading = false;
            },
            opts: {err_404_message: 'Error loading import form'}
        })
    },
    methods: {
        save: function () {
            var cmp = this;
            cmp.loaded = false;

            cmp.$emit('updateErrors', {});
            cmp.errorsKey += 1;

            const data = new FormData();
            data.append('results_set', cmp.results_set);
            data.append('file', cmp.file);

            AjaxUtils.ajax_post({
                url: this.url,
                data: data,
                opts: {
                    processData: false,
                    contentType: false,
                },
                success: function (json, status, xhr) {
                    cmp.loaded = true;
                    cmp.$emit('vulnsImported', null);
                    cmp.$emit('close');
                },
                fail: function (json, status, xhr) {
                    cmp.$emit('updateErrors', json?.field_errors ? json.field_errors : {});
                    cmp.errorsKey += 1;
                    cmp.loaded = true;
                }
            });
        },
    },
    template: `
        <div ref="modal" :key="errorsKey">
            <apck-field :errors="errors?.results_set">
                <apck-select
                    v-model="results_set"
                    label="Results Set"
                    :options="results_set_options"
                />
            </apck-field>
            
            <apck-field :errors="errors?.file">
                <apck-file-upload label="Upload a file (Max 100MB)" v-model="file" v-on:input="$emit('updateErrors', {});"/>
            </apck-field>
            
            <apck-accordion title="Supported file types" collapsed>
                <table class="table supported-import-type">
                    <thead>
                    <tr>
                        <th>Scanner</th>
                        <th>Format</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>NMap</td>
                        <td>.xml</td>
                    </tr>
                    <tr>
                        <td>Burp Suite</td>
                        <td>.xml</td>
                    </tr>
                    <tr>
                        <td>Nessus</td>
                        <td>.nessus</td>
                    </tr>
                    <tr>
                        <td>Nexpose</td>
                        <td>.xml</td>
                    </tr>
                    <tr>
                        <td>Appcheck</td>
                        <td>.json</td>
                    </tr>
                    </tbody>
                </table>
            </apck-accordion>
            
            <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="save"/>
            <apck-mask :trigger="loading" :target="(mask) => mask.$parent.$parent.$refs.lightboxouter"/>
        </div>
    `
}


const ApckTreeRowBase =  /*#__PURE__*/ ApckTooltipBase.extend({
    methods: {
        updateTooltipPosition() {
            const cmp = this;
            if (!this.showTooltip || !this.$refs.rowActions) {
                return;
            }
            const parentRect = this.$refs.rowActions.getBoundingClientRect();
            this.tooltipTop = parentRect.top;
            this.tooltipLeft = parentRect.right + 10;

            this.$nextTick(() => {
                const tooltip = cmp.$refs.tooltip;
                if (!tooltip) return;
                const rect = tooltip.getBoundingClientRect();
                const window_height = getWindowDimensions().height;
                const window_width = getWindowDimensions().width;

                if (rect.bottom > window_height) {
                    cmp.tooltipBottom = window_height - parentRect.top;
                }
                if (rect.right > (window_width - 32)) {
                    cmp.tooltipRight = window_width - parentRect.left - 10;
                }
            });
        },
        handleClickOutside(event) {
            if (this.$data._preventCloseOnClickOutside) {
                this.$data._preventCloseOnClickOutside = false;
                return;
            }
            if (this.showTooltip && !this.$refs.rowActions.contains(event.target)) {
                this.closeTooltip();
            }
        },
    },
    data() {
        return {
            showFilterTooltip: false,
            showTooltip: false,
        }
    }
});


export const ApckVulnDetailsTableRow = /*#__PURE__*/ ApckTreeRowBase.extend({
    components: {
        'apck-cvss-col': ApckCvssCol,
        'apck-column-actions': ApckColumnActions,
    },
    props: {
        row: {
            type: Object,
            required: true
        },
        allRows: {
            type: Array,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        table: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        showTitle: {
            type: Boolean,
            default: false
        },
    },
    data: function () {
        return {
            modal: {
                prevDisabled: false,
                nextDisabled: false,
            }
        }
    },
    computed: {
        selected() {
            return this.table.selectedVulns.indexOf(this.row._id) !== -1;
        },
    },
    destroyed() {
        this.table.deselectRow(this.row);
    },
    methods: {
        rowClick(row) {
            const cmp = this;
            const clearTabQueryParam = () => {
                // remove tab from query params
                const query = cmp.$route?.query || {};
                delete query['tab'];
                // for some reason we need to fully clear the query params first...
                cmp.$router.replace({'query': undefined});
                cmp.$router.replace({'query': query});
            };

            const ids = this.allRows.map(obj => obj._id)

            cmp.$modal.open({
                title: "Vulnerability Details",
                component: ApckVulnDetailsRollout,
                bind: {
                    _ids: ids,
                    initial_id: row._id
                },
                on: {
                    'workflow-updated': () => {
                        cmp.$emit('vulns-updated');
                    },
                },
                size: 'lg',
                fullHeight: true,
                justify: 'end',
                headerButtons:
                    ids.length > 1 ? [
                        {
                            key: 'previous',
                            type: 'ghost',
                            iconLeft: 'fa-chevron-left',
                            label: 'Previous',
                            hideLabel: true,
                            disabled: false,
                            action: ({component}) => {
                                component.previous()
                            },
                        },
                        {
                            key: 'next',
                            type: 'ghost',
                            iconLeft: 'fa-chevron-right',
                            label: 'Next',
                            hideLabel: true,
                            disabled: false,
                            action: ({ component }) => {
                                component.next()
                            },
                        },
                    ] : [],
                beforeopen: () => {clearTabQueryParam();},
                beforeclose: () => {clearTabQueryParam();},
            })
        },
        deleteRow(row, index) {
            const cmp = this;

            cmp.$dialog.confirm(
                `Are you sure you want to delete this "${cmp.title}" vulnerability?`,
                'Delete vulnerability',
                function () {
                    deleteVulnerabilities({
                        cmp: cmp,
                        url: `${cmp.table.apiUrl}/delete`,
                        data: {'_id': row._id},
                        success_cb: function (resp) {
                            // count is always 1 here, because we are deleting a single row item
                            const count = resp.count || 0;

                            cmp.allRows.splice(index, 1);

                            cmp.$emit('row-deleted', count);

                            // reduce status counts
                            cmp.table.status[row.status] -= count;
                        }
                    });
                }
            );
        },
        filterAssignee(row) {
            let assignee = 'null';
            if (row.assigned_id) {
                assignee = row.assigned_id;
            }
            this.table.query.assignee_id = assignee;
        },
        filterHost(row) {
            let host = ['all'];
            if (row.host) {
                host = [row.host];
            }
            this.table.query.host = host;
        },
        filterIpv4(row) {
            if (row.ipv4_address) {
                this.table.query.ipv4 = [row.ipv4_address];
            } else {
                this.table.query.ipv4 = [];
            }
        },
        copyID(row) {
            navigator.clipboard.writeText(row._id);
            this.$flash({type: 'success', message: 'Copied ID'});
        },
        formatUnixDate(ts) {
            if (!ts) return '-';
            try {
                const d = new Date(ts * 1000);
                const iso = d.toISOString();
                // YYYY-MM-DD HH:MM:SS
                return iso.substring(0, 10) + ' ' + iso.substring(11, 19);
            } catch(e) {
                return '-';
            }
        },
        updateTableFilterSearch(field, value, operator) {
            this.table.searchTokensUpdated([
                ...cloneDeep(this.table.$data.filter_search),
                {
                    "type": field,
                    "value": {"data": value, "operator": operator},
                }]
            );
        },
        openVulnPage(row) {
            if (this.table.vulnUrl) {
                window.location.href = String.format(this.table.vulnUrl, row._id);
            } else {
                this.$router.push({
                    name: 'vulnerabilities.view',
                    params: {
                        vulnerability_id: row._id
                    },
                })
            }
        },
        select(row) {
            if (this.selected) {
                this.table.deselectRow(row);
            } else {
                this.table.selectRow(row);
            }
        },
    },
    template: `
        <tr @click="rowClick(row)">
            <td @click.stop class="select-cell">
                <ui-input-checkbox
                    label="Select row"
                    hideLabel
                    :modelValue="selected"
                    @update:modelValue="select(row)"
                />
            </td>
            <td v-if="showTitle" class="cell-actions-hover vuln-title-cell">
                <apck-col-wrapper>
                    <i :class="['fa', 'fa-circle', 'icon', 'severity-icon-' + row.impact]" :title="'Impact: ' + (row.impact || 'unknown')"></i>
                    {{ row.title }}
                </apck-col-wrapper>
            </td>
          
            <td class="cell-actions-hover">
                <ui-layout gap="0" align="center">
                    <apck-col-wrapper class="grow">
                        {{ row.host || '-' }}
                    </apck-col-wrapper>
                    
                    <ui-tooltip :class="['filter-tooltip', showFilterTooltip ? 'tooltip-open' : '' ]" placement="right" triggerOnClick @update:open="showFilterTooltip = $event">
                        <template #content>
                            <ui-layout direction="column" gap="1">
                                <ui-button
                                    label="Filter by host"
                                    iconLeft="fa-search"
                                    @click.native="filterHost(row)"
                                    data-close-tooltip
                                />
                            </ui-layout>
                        </template>
    
                        <ui-icon
                            type="secondary"
                            icon="fa-solid fa-filter"
                            size="md"
                        />
                    </ui-tooltip>
                </ui-layout>
            </td>
            <td class="cell-actions-hover">
                <ui-layout gap="0" align="center">
                    <apck-col-wrapper class="grow">
                        {{ row.ipv4_address || '-' }}
                    </apck-col-wrapper>

                    <ui-tooltip :class="['filter-tooltip', showFilterTooltip ? 'tooltip-open' : '' ]" placement="right" triggerOnClick @update:open="showFilterTooltip = $event">
                        <template #content>
                            <ui-layout direction="column" gap="1">
                                <ui-button
                                    label="Filter by IP"
                                    iconLeft="fa-search"
                                    @click.native="filterIpv4(row)"
                                    data-close-tooltip
                                />
                            </ui-layout>
                        </template>

                        <ui-icon
                            type="secondary"
                            icon="fa-solid fa-filter"
                            size="md"
                        />
                    </ui-tooltip>
                </ui-layout>
            </td>
            <td class="cell-actions-hover">
                <ui-layout gap="0" align="center">
                    <apck-col-wrapper>
                        {{ row.port || '-' }}
                    </apck-col-wrapper>

                    <ui-tooltip :class="['filter-tooltip', showFilterTooltip ? 'tooltip-open' : '' ]" placement="right" triggerOnClick @update:open="showFilterTooltip = $event">
                        <template #content>
                            <ui-layout direction="column" gap="1">
                                <ui-button
                                    v-for="operator in table.filter_tokens.find((el) => el.type === 'port').operators"
                                    :key="'port' + operator.value"
                                    :label="'Filter by: Port ' + operator.description + ' (' + row.port + ')'"
                                    iconLeft="fa-search"
                                    @click.native="updateTableFilterSearch('port', row.port, operator.value)"
                                    data-close-tooltip
                                    ellipsis
                                />
                            </ui-layout>
                        </template>

                        <ui-icon
                            type="secondary"
                            icon="fa-solid fa-filter"
                            size="md"
                        />
                    </ui-tooltip>
                </ui-layout>
            </td>
            
            <td class="cell-actions-hover">
                <ui-layout gap="0" align="center">
                    <apck-col-wrapper class="grow">
                        {{ table.$data.users[row.assigned_id]?.name || '-' }}
                    </apck-col-wrapper>

                    <ui-tooltip :class="['filter-tooltip', showFilterTooltip ? 'tooltip-open' : '' ]" placement="right" triggerOnClick @update:open="showFilterTooltip = $event">
                        <template #content>
                            <ui-layout direction="column" gap="1">
                                <ui-button
                                    label="Filter by assignee"
                                    iconLeft="fa-search"
                                    @click.native="filterAssignee(row)"
                                    data-close-tooltip
                                />
                            </ui-layout>
                        </template>

                        <ui-icon
                            type="secondary"
                            icon="fa-solid fa-filter"
                            size="md"
                        />
                    </ui-tooltip>
                </ui-layout>
            </td>
            
            <td v-if="showTitle" class="cell-nowrap">
                <apck-col-wrapper>
                    {{ formatUnixDate(row.last_detected_at) }}
                </apck-col-wrapper>
            </td>
            
            <td data-label="Actions">
                <div class="cell actions">
                    <ui-tooltip :class="['actions-tooltip', showTooltip ? 'tooltip-open' : '' ]" placement="left" triggerOnClick @update:open="showTooltip = $event">
                        <template #content>
                            <ui-layout direction="column" gap="1">
                                <ui-button
                                    label="View vulnerability"
                                    iconLeft="fa-eye"
                                    @click.native="openVulnPage(row)"
                                    data-close-tooltip
                                />

                                <ui-button
                                    label="Copy vulnerability ID"
                                    iconLeft="fa-copy"
                                    @click.native="copyID(row)"
                                    data-close-tooltip
                                />

                                <ui-button
                                    label="Delete vulnerability"
                                    iconLeft="fa-trash"
                                    @click.native="deleteRow(row, index)"
                                    data-close-tooltip
                                />
                            </ui-layout>
                        </template>

                        <ui-icon
                            type="secondary"
                            icon="fa-ellipsis-h"
                            size="2xl"
                        />
                    </ui-tooltip>
                </div>
            </td>
        </tr>
    `
});


export const ApckVulnDetails = {
    components: {
        'apck-vuln-details-table-row': ApckVulnDetailsTableRow
    },
    props: {
        table: {
            type: Object,
            default: null
        },
        title: {
            type: String,
            default: ''
        },
        row: {
            type: Object,
            default: function() {
                return {};
            }
        },
        filter: {
            type: Object,
            default: function() {
                return {};
            }
        },
        rows: {
            type: Array,
            default: function() {
                return [];
            }
        },
        showTitle: {
            type: Boolean,
            default: false
        },
    },
    data: function () {
        return {
            expanded: false,
        }
    },
    computed: {
        allSelected() {
            if (!this.rows.length || !this.table) return false;
            const sel = new Set(this.table.selectedVulns);
            return this.rows.every(r => sel.has(r._id));
        },
        someSelected() {
            if (!this.rows.length || !this.table) return false;
            const sel = new Set(this.table.selectedVulns);
            return !this.allSelected && this.rows.some(r => sel.has(r._id));
        },
    },
    methods: {
        expand() {
            this.expanded = !this.expanded;
        },
        toggleSelectAll() {
            if (!this.table) return;
            if (this.allSelected) {
                this.rows.forEach(r => this.table.deselectRow(r));
            } else {
                this.rows.forEach(r => this.table.selectRow(r));
            }
        },
    },
    template: `
        <table class="apck-table">
            <thead>
                <tr>
                    <th style="width: 42px;" class="select-header">
                        <ui-input-checkbox
                            :label="allSelected ? 'Deselect all on page' : 'Select all on page'"
                            hideLabel
                            :modelValue="allSelected"
                            @update:modelValue="toggleSelectAll"
                        />
                    </th>
                    <th v-if="showTitle" style="width: 150px;">
                        <div class="cell header">
                            <span class="cell-value">
                                Title
                            </span>
                        </div>
                    </th>
                  
                    <th style="width: 20%;">
                        <div class="cell header">
                            <span class="cell-value">
                                Host
                            </span>
                        </div>
                    </th>
                    <th style="width: 130px;">
                        <div class="cell header">
                            <span class="cell-value">
                                IP
                            </span>
                        </div>
                    </th>
                    <th style="width: 90px;">
                        <div class="cell header">
                            <span class="cell-value">
                                Port
                            </span>
                        </div>
                    </th>
                    
                    <th style="width: 20%;">
                        <div class="cell header">
                            <span class="cell-value">
                                Assignee
                            </span>
                        </div>
                    </th>
                    
                    <th v-if="showTitle" style="width: 170px;">
                        <div class="cell header">
                            <span class="cell-value">
                                Last Detected (UTC)
                            </span>
                        </div>
                    </th>
                  
                    <th style="width: auto;">
                        <div class="cell header">
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <apck-vuln-details-table-row 
                    v-for="(row, index) in rows"
                    :key="row._id"
                    :row="row"
                    :allRows="rows"
                    :index="index"
                    :table="table"
                    :title="row.title || title"
                    :showTitle="showTitle"
                    @row-deleted="$emit('row-deleted', $event)"
                />
                <tr v-if="expanded">
                    <td colspan=7>
                        {{ rows[0].description }}
                    </td>
                </tr>
            </tbody>
        </table>
    `
}


export const ApckTreeTitleRow =  /*#__PURE__*/ ApckTreeRowBase.extend({
    components: {
        'apck-vuln-details': ApckVulnDetails,
    },
    props: {
        level: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        host: {
            type: String,
            default: null
        },
        is_ipv4: {
            type: Boolean,
            default: null
        },
        owasp: {
            type: String,
            default: null
        },
        owaspYear: {
            type: String,
            default: null
        },
        countProp: {
            type: Number,
            default: 0
        },
        table: {
            type: Object,
            default: null
        }
    },
    data: function() {
        return {
            expanded: false,
            dataTableRows: [],
            count: 0,
        };
    },
    created() {
        this.count = this.countProp;
    },
    watch: {
        countProp() {
            this.count = this.countProp;
        }
    },
    methods: {
        fetch() {
            const cmp = this;
            let params = {};
            if(this.table) {
                params = this.table.buildQueryParams();
                params.title = this.value;
                if (this.host) {
                    if (this.is_ipv4) {
                        params.ipv4 = [this.host];
                    } else {
                        params.hosts = [this.host];
                    }
                }
                if (this.owasp && this.owaspYear) {
                    params['owasp'] = this.owasp;
                    params['owasp_year'] = this.owaspYear;
                }

                if (this.level === 'critical') {
                    params.impact = ['5.0-critical'];
                } else if (this.level === 'high') {
                    params.impact = ['4.0-high'];
                } else if (this.level === 'medium') {
                    params.impact = ['3.0-medium'];
                } else if (this.level === 'low') {
                    params.impact = ['2.0-low'];
                } else if (this.level === 'info') {
                    params.impact = ['1.0-info'];
                }

                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }

                AjaxUtils.ajax_get({
                    url: `${cmp.table.apiUrl}/list`,
                    query_params: params,
                    traditional: true,
                    success: function (data) {
                        cmp.dataTableRows = data.items;
                    },

                });
            }
        },
        expand() {
            this.expanded = !this.expanded;
            if (this.expanded) {
                this.fetch();
            }
        },
        deleteRow() {
            const cmp = this;

            if(this.table) {
                const params = this.table.buildQueryParams();
                params['title'] = this.value;
                if (this.host) {
                    if (this.is_ipv4) {
                        params.ipv4 = [this.host];
                    } else {
                        params.hosts = [this.host];
                    }
                }
                if (this.owasp && this.owaspYear) {
                    params['owasp'] = this.owasp;
                    params['owasp_year'] = this.owaspYear;
                }
                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }
                const queryParams = $.param(params, true);

                const pluralCount = cmp.count > 1 ? `all ${cmp.count}`: 'this';
                const pluralVuln = cmp.count > 1 ? 'vulnerabilities': 'vulnerability';
                cmp.$dialog.confirm(
                    `Are you sure you want to delete ${pluralCount} "${cmp.value}" ${pluralVuln}?`,
                    `Delete ${cmp.count} ${pluralVuln}`,
                    function () {
                        deleteVulnerabilities({
                            cmp: cmp,
                            url: `${cmp.table.apiUrl}/delete?${queryParams}`,
                            success_cb: function (resp) {
                                const count = resp.count || 0;
                                const status_counts = resp.status_counts;

                                cmp.childVulnsDeleted(count);

                                // reduce status counts
                                Object.entries(status_counts).forEach(([status, val]) => {
                                    cmp.table.status[status] -= val;
                                });
                            }
                        })
                    }
                );
            }
        },
        addToSearch() {
            this.table.searchTokensUpdated([
                ...cloneDeep(this.table.$data.filter_search),
                {
                    "type": "title",
                    "value": {"data": this.value, "operator": '='},
                }]
            );
        },
        excludeSearch() {
            this.table.searchTokensUpdated([
                ...cloneDeep(this.table.$data.filter_search),
                {
                    "type": "title",
                    "value": {"data": this.value, "operator": '!='},
                }]
            );
        },
        childVulnsDeleted(count) {
            this.count -= count;

            if (this.count < 1) {
                const index = this.table.titles.findIndex(item => {
                    return item.title === this.value && item.impact === this.level;
                });
                if (index !== -1) {
                    this.table.titles.splice(index, 1);
                }
            }
            this.$emit('title-row-deleted', {titleRow: this, count: count});
        },
        _buildTitleParams() {
            const params = this.table.buildQueryParams();
            params['title'] = this.value;
            if (this.host) {
                if (this.is_ipv4) {
                    params.ipv4 = [this.host];
                } else {
                    params.hosts = [this.host];
                }
            }
            if (this.owasp && this.owaspYear) {
                params['owasp'] = this.owasp;
                params['owasp_year'] = this.owaspYear;
            }
            if (this.table.results_set_ids !== null) {
                params['results_set_ids'] = this.table.results_set_ids;
            }
            return params;
        },
        bulkAssignUser() {
            const cmp = this;
            const params = cmp._buildTitleParams();
            let assignee_options = Object.entries(cmp.table.users).map(([key, value]) => ({label: value.name, value: key}));
            assignee_options = [
                {'label': '--- unassigned ---', 'value': null},
                ...assignee_options,
            ];
            cmp.$modal.open({
                title: `Set assignee for ${cmp.count} "${cmp.value}" vulnerabilities`,
                component: ApckVulnBulkAssigneeForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/assign?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    assignee_options: assignee_options,
                    selected_vulns: [],
                },
                on: {
                    'assignee-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.table.fetchUserCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Assigned user to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkSetPriority() {
            const cmp = this;
            const params = cmp._buildTitleParams();
            cmp.$modal.open({
                title: `Set priority for ${cmp.count} "${cmp.value}" vulnerabilities`,
                component: ApckVulnBulkPriorityForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/priority?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'priority-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated priority of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkSetStatus() {
            const cmp = this;
            const params = cmp._buildTitleParams();
            cmp.$modal.open({
                title: `Set status for ${cmp.count} "${cmp.value}" vulnerabilities`,
                component: ApckVulnBulkStatusForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/status?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'status-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated status of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkAddNotes() {
            const cmp = this;
            const params = cmp._buildTitleParams();
            cmp.$modal.open({
                title: `Add notes for ${cmp.count} "${cmp.value}" vulnerabilities`,
                component: ApckVulnBulkNotesForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/notes?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'notes-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Added notes to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
    },
    template: `
        <li>
            <div class="cell" @click="expand()">
                <a href="javascript:;" class="expander">
                    <i :class="['fa', expanded ? 'fa-caret-down' : 'fa-caret-right']"></i>
                </a>
                <i :class="['fa', 'fa-circle', 'icon', 'severity-icon-' + level]"></i>
                <span class="vuln-group-header">
                    <span class="vuln-group-header-text">{{ value }}</span> <span>( {{ count }} )</span>
                </span>

                <ui-tooltip :class="['actions-tooltip', showTooltip ? 'tooltip-open' : '' ]" placement="left" triggerOnClick @update:open="showTooltip = $event">
                    <template #content>
                        <ui-layout direction="column" gap="1">
                            <ui-button
                                label="Assign user"
                                iconLeft="fa-user"
                                @click.native="bulkAssignUser"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Set priority"
                                iconLeft="fa-sort-amount-desc"
                                @click.native="bulkSetPriority"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Change status"
                                iconLeft="fa-check-circle"
                                @click.native="bulkSetStatus"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Add notes"
                                iconLeft="fa-pen-to-square"
                                @click.native="bulkAddNotes"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Search by title"
                                iconLeft="fa-search"
                                @click.native="addToSearch"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Exclude title"
                                iconLeft="fa-search"
                                @click.native="excludeSearch"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Delete"
                                iconLeft="fa-trash"
                                @click.native="deleteRow"
                                data-close-tooltip
                            />
                        </ui-layout>
                    </template>

                    <ui-icon
                        type="secondary"
                        icon="fa-ellipsis-h"
                        size="2xl"
                    />
                </ui-tooltip>
            </div>
            <div class="table-container" v-if="expanded">
                <apck-vuln-details
                    :table="table"
                    :title="value"
                    :rows="dataTableRows"
                    ref="table"
                    @row-deleted="childVulnsDeleted($event)"
                    @vulns-updated="fetch()"
                />
            </div>
        </li>
    `
});

export const ApckTreeImpactRow = ApckTreeRowBase.extend({
    components: {
        'apck-tree-title-row': ApckTreeTitleRow,
    },
    props: {
        level: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        countProp: {
            type: Number,
            default: 0
        },
        table: {
            type: Object,
            default: null
        },
        rows: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data: function() {
        return {
            count: 0,
            expanded: false,
            loading: false
        };
    },
    created() {
        this.count = this.countProp;
    },
    watch: {
        countProp() {
            this.count = this.countProp;
        }
    },
    methods: {
        expand() {
            this.expanded = !this.expanded;
        },
        deleteRow() {
            const cmp = this;

            if(this.table) {
                const params = this.table.buildQueryParams();
                if(this.value === 'Critical') {
                    params['impact'] = ['5.0-critical'];
                }
                if (this.value === 'High') {
                    params['impact'] = ['4.0-high'];
                }
                if (this.value === 'Medium') {
                    params['impact'] = ['3.0-medium'];
                }
                if (this.value === 'Low') {
                    params['impact'] = ['2.0-low'];
                }
                if (this.value === 'Info') {
                    params['impact'] = ['1.0-info'];
                }
                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }
                const queryParams = $.param(params, true);

                const pluralVuln = cmp.count > 1 ? 'vulnerabilities': 'vulnerability';
                cmp.$dialog.confirm(
                    `Are you sure you want to delete all ${cmp.count} "${cmp.value} impact" vulnerabilities?`,
                    `Delete ${cmp.count} ${pluralVuln}`,
                    function () {
                        deleteVulnerabilities({
                            cmp: cmp,
                            url: `${cmp.table.apiUrl}/delete?${queryParams}`,
                            success_cb: function (resp) {
                                const count = resp.count || 0;
                                const status_counts = resp.status_counts;

                                cmp.count -= count;
                                cmp.cleanupEmptyRow();

                                cmp.$emit('impact-row-deleted', {impactRow: cmp, count: count})

                                // reduce status counts
                                Object.entries(status_counts).forEach(([status, val]) => {
                                    cmp.table.status[status] -= val;
                                });
                            }

                        })
                    }
                );
            }
        },
        childRowDeleted({titleRow, count}) {
            this.count -= count;

            // if this impact row is empty, remove it from the table
            if (this.count < 1) {
                this.cleanupEmptyRow();
            }

            this.$emit('impact-row-deleted', {impactRow: this, count: count})
        },
        cleanupEmptyRow() {
            // remove these rows from the table titles array
            const indexes = this.table.titles.flatMap(
                (item, i) => item.impact === this.level ? i : []
            );
            this.table.titles = this.table.titles.filter(
                (value, index) => indexes.indexOf(index) === -1
            )
        },
        _buildImpactParams() {
            const params = this.table.buildQueryParams();
            const impactMap = {
                'Critical': '5.0-critical',
                'High': '4.0-high',
                'Medium': '3.0-medium',
                'Low': '2.0-low',
                'Info': '1.0-info',
            };
            if (impactMap[this.value]) {
                params['impact'] = [impactMap[this.value]];
            }
            if (this.table.results_set_ids !== null) {
                params['results_set_ids'] = this.table.results_set_ids;
            }
            return params;
        },
        bulkAssignUser() {
            const cmp = this;
            const params = cmp._buildImpactParams();
            let assignee_options = Object.entries(cmp.table.users).map(([key, value]) => ({label: value.name, value: key}));
            assignee_options = [
                {'label': '--- unassigned ---', 'value': null},
                ...assignee_options,
            ];
            cmp.$modal.open({
                title: `Set assignee for ${cmp.count} "${cmp.value}" impact vulnerabilities`,
                component: ApckVulnBulkAssigneeForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/assign?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    assignee_options: assignee_options,
                    selected_vulns: [],
                },
                on: {
                    'assignee-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.table.fetchUserCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Assigned user to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkSetPriority() {
            const cmp = this;
            const params = cmp._buildImpactParams();
            cmp.$modal.open({
                title: `Set priority for ${cmp.count} "${cmp.value}" impact vulnerabilities`,
                component: ApckVulnBulkPriorityForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/priority?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'priority-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated priority of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkSetStatus() {
            const cmp = this;
            const params = cmp._buildImpactParams();
            cmp.$modal.open({
                title: `Set status for ${cmp.count} "${cmp.value}" impact vulnerabilities`,
                component: ApckVulnBulkStatusForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/status?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'status-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated status of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkAddNotes() {
            const cmp = this;
            const params = cmp._buildImpactParams();
            cmp.$modal.open({
                title: `Add notes for ${cmp.count} "${cmp.value}" impact vulnerabilities`,
                component: ApckVulnBulkNotesForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/notes?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'notes-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Added notes to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
    },
    template: `
        <li>
            <div class="cell" @click="expand()">
                <a v-if="!loading" href="javascript:;" class="expander">
                    <i :class="['fa', expanded ? 'fa-caret-down' : 'fa-caret-right']"></i>
                </a>
                <a v-if="loading" href="javascript:;" class="expander">
                    <i :class="['fa', 'fa-spinner', 'fa-spin']"></i>
                </a>
                <i :class="['fa', 'fa-circle', 'icon', 'severity-icon-' + level]"></i>
                <span class="vuln-group-header">
                    <span class="vuln-group-header-text">{{ value }}</span> <span>( {{ count }} )</span>
                </span>

                <ui-tooltip :class="['actions-tooltip', showTooltip ? 'tooltip-open' : '' ]" placement="left" triggerOnClick @update:open="showTooltip = $event">
                    <template #content>
                        <ui-layout direction="column" gap="1">
                            <ui-button
                                label="Assign user"
                                iconLeft="fa-user"
                                @click.native="bulkAssignUser"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Set priority"
                                iconLeft="fa-sort-amount-desc"
                                @click.native="bulkSetPriority"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Change status"
                                iconLeft="fa-check-circle"
                                @click.native="bulkSetStatus"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Add notes"
                                iconLeft="fa-pen-to-square"
                                @click.native="bulkAddNotes"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Delete"
                                iconLeft="fa-trash"
                                @click.native="deleteRow"
                                data-close-tooltip
                            />
                        </ui-layout>
                    </template>

                    <ui-icon
                        type="secondary"
                        icon="fa-ellipsis-h"
                        size="2xl"
                    />
                </ui-tooltip>
            </div>
            <ul v-if="expanded">
                <apck-tree-title-row
                    v-if="row.impact === level"
                    v-for="row in table.titles"
                    :key="row.title + row.impact + row.count"
                    :value="row.title"
                    :level="row.impact"
                    :count-prop="row.count"
                    :table="table"
                    @title-row-deleted="childRowDeleted($event)"
                />
            </ul>
        </li>
    `
});

export const ApckTreeHostRow = ApckTreeRowBase.extend({
    components: {
        'apck-tree-title-row': ApckTreeTitleRow,
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        countProp: {
            type: Number,
            default: 0
        },
        criticalProp: {
            type: Number,
            default: 0
        },
        highProp: {
            type: Number,
            default: 0
        },
        mediumProp: {
            type: Number,
            default: 0
        },
        lowProp: {
            type: Number,
            default: 0
        },
        infoProp: {
            type: Number,
            default: 0
        },
        table: {
            type: Object,
            default: null
        },
        is_ipv4: false
    },
    data: function() {
        return {
            count: 0,
            critical: 0,
            high: 0,
            medium: 0,
            low: 0,
            info: 0,
            expanded: false,
            rows: [],
        };
    },
    created() {
        this.count = this.countProp;
        this.critical = this.criticalProp;
        this.high = this.highProp;
        this.medium = this.mediumProp;
        this.low = this.lowProp;
        this.info = this.infoProp;
    },
    watch: {
        countProp() {
            this.count = this.countProp;
        },
        criticalProp() {
            this.critical = this.criticalProp;
        },
        highProp() {
            this.high = this.highProp;
        },
        mediumProp() {
            this.medium = this.mediumProp;
        },
        lowProp() {
            this.low = this.lowProp;
        },
        infoProp() {
            this.info = this.infoProp;
        },
    },
    methods: {
        fetch() {
            const cmp = this;
            if (this.table) {
                let params = this.table.buildQueryParams();
                if (this.is_ipv4) {
                    params['ipv4'] = [this.value];
                } else {
                    params['hosts'] = [this.value];
                }
                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }
                AjaxUtils.ajax_get({
                    url: `${cmp.table.apiUrl}/title`,
                    query_params: params,
                    traditional: true,
                    success: (data) => {
                        if (data) {
                            cmp.rows = data.items;
                        }
                    },
                });
            }
        },
        expand() {
            this.expanded = !this.expanded;
            if(this.expanded && this.rows.length === 0) {
                this.fetch();
            }
        },
        deleteRow() {
            const cmp = this;

            if (this.table) {
                console.log(this.table.query);
                const params = this.table.buildQueryParams();
                if (this.is_ipv4) {
                    params['ipv4'] = [this.value];
                } else {
                    params['hosts'] = [this.value];
                }
                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }
                const queryParams = $.param(params, true);

                const pluralCount = cmp.count > 1 ? `all ${cmp.count}`: 'this';
                const pluralVuln = cmp.count > 1 ? 'vulnerabilities': 'vulnerability';
                cmp.$dialog.confirm(
                    `Are you sure you want to delete ${pluralCount} ${pluralVuln} with host "${cmp.value}"?`,
                    `Delete ${cmp.count} ${pluralVuln}`,
                    function () {
                        deleteVulnerabilities({
                            cmp: cmp,
                            url: `${cmp.table.apiUrl}/delete?${queryParams}`,
                            success_cb: function (resp) {
                                const count = resp.count || 0;
                                const status_counts = resp.status_counts;

                                cmp.count -= count;
                                cmp.cleanupEmptyRow();

                                cmp.$emit('host-row-deleted', {hostRow: cmp, count: count})

                                // reduce status counts
                                Object.entries(status_counts).forEach(([status, val]) => {
                                    cmp.table.status[status] -= val;
                                });
                            }

                        })
                    }
                );
            }
        },
        childRowDeleted({titleRow, count}) {
            this.count -= count;
            this.$data[titleRow.level] -= count;
            this.table.impact[titleRow.level] -= count;

            // If the title row has no vulns, remove it from the list
            if (titleRow.count < 1) {
                const index = this.rows.findIndex(item => {
                    return item.title === titleRow.value && item.impact === titleRow.level;
                });
                if (index !== -1) {
                    this.rows.splice(index, 1);
                }
            }

            // if this host row is empty, remove it from the table
            if (this.count < 1) {
                this.cleanupEmptyRow();
            }

            this.$emit('host-row-deleted', {hostRow: this, count: count})
        },
        cleanupEmptyRow() {
            // there are no child vulnerabilities, so we call this to remove the host row from the table
            if (this.is_ipv4) {
                delete this.table.ipv4[this.value];
            } else {
                delete this.table.hosts[this.value];
            }
        },
        _buildHostParams() {
            const params = this.table.buildQueryParams();
            if (this.is_ipv4) {
                params['ipv4'] = [this.value];
                delete params['hosts'];
            } else {
                params['hosts'] = [this.value];
                delete params['ipv4'];
            }
            if (this.table.results_set_ids !== null) {
                params['results_set_ids'] = this.table.results_set_ids;
            }
            return params;
        },
        bulkAssignUser() {
            const cmp = this;
            const params = cmp._buildHostParams();
            let assignee_options = Object.entries(cmp.table.users).map(([key, value]) => ({label: value.name, value: key}));
            assignee_options = [
                {'label': '--- unassigned ---', 'value': null},
                ...assignee_options,
            ];
            cmp.$modal.open({
                title: `Set assignee for ${cmp.count} vulnerabilities with host "${cmp.value}"`,
                component: ApckVulnBulkAssigneeForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/assign?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    assignee_options: assignee_options,
                    selected_vulns: [],
                },
                on: {
                    'assignee-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.table.fetchUserCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Assigned user to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkSetPriority() {
            const cmp = this;
            const params = cmp._buildHostParams();
            cmp.$modal.open({
                title: `Set priority for ${cmp.count} vulnerabilities with host "${cmp.value}"`,
                component: ApckVulnBulkPriorityForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/priority?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'priority-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated priority of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkSetStatus() {
            const cmp = this;
            const params = cmp._buildHostParams();
            cmp.$modal.open({
                title: `Set status for ${cmp.count} vulnerabilities with host "${cmp.value}"`,
                component: ApckVulnBulkStatusForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/status?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'status-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated status of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
        bulkAddNotes() {
            const cmp = this;
            const params = cmp._buildHostParams();
            cmp.$modal.open({
                title: `Add notes for ${cmp.count} vulnerabilities with host "${cmp.value}"`,
                component: ApckVulnBulkNotesForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/notes?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'notes-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Added notes to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            });
        },
    },
    computed: {
        level() {
            let value = 'info';
            if(this.low > 0) {
                value = 'low';
            }
            if(this.medium > 0) {
                value = 'medium';
            }
            if(this.high > 0) {
                value = 'high';
            }
            if(this.critical > 0) {
                value = 'critical';
            }
            return value;
        }
    },
    template: `
        <li>
            <div class="cell" @click="expand()">
                <a href="javascript:;" class="expander">
                    <i :class="['fa', expanded ? 'fa-caret-down' : 'fa-caret-right']"></i>
                </a>
                <i :class="['fa', 'fa-circle', 'icon', 'severity-icon-' + level]"></i>
                <span class="vuln-group-header">
                    <span class="vuln-group-header-text">{{ value }}</span>
                    <span>( Total: {{ count }} ) -
                        ( 
                            <b class="severity-icon-critical" v-if="table && table.showCriticalFilter">
                                {{critical}}
                            </b> /
                            <b class="severity-icon-high">
                                {{high}}
                            </b> /
                            <b class="severity-icon-medium">
                                {{medium}}
                            </b> /
                            <b class="severity-icon-low">
                                {{low}}
                            </b> /
                            <b class="severity-icon-info">
                                {{info}}
                            </b> 
                        )
                    </span>
                </span>
                <ui-tooltip :class="['actions-tooltip', showTooltip ? 'tooltip-open' : '' ]" placement="left" triggerOnClick @update:open="showTooltip = $event">
                    <template #content>
                        <ui-layout direction="column" gap="1">
                            
                            <ui-button
                                label="Assign user"
                                iconLeft="fa-user"
                                @click.native="bulkAssignUser"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Set priority"
                                iconLeft="fa-sort-amount-desc"
                                @click.native="bulkSetPriority"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Change status"
                                iconLeft="fa-check-circle"
                                @click.native="bulkSetStatus"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Add notes"
                                iconLeft="fa-pen-to-square"
                                @click.native="bulkAddNotes"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Delete"
                                iconLeft="fa-trash"
                                @click.native="deleteRow"
                                data-close-tooltip
                            />
                        </ui-layout>
                    </template>

                    <ui-icon
                        type="secondary"
                        icon="fa-ellipsis-h"
                        size="2xl"
                    />
                </ui-tooltip>
            </div>
            <ul v-if="expanded">
                <apck-tree-title-row
                    v-for="row in rows"
                    :key="row.title + row.impact + row.count"
                    :value="row.title"
                    :level="row.impact"
                    :host="value"
                    :is_ipv4="is_ipv4"
                    :count-prop="row.count"
                    :table="table"
                    @title-row-deleted="childRowDeleted($event)"
                />
            </ul>
        </li>
    `
});

export const ApckTreeOwaspRow = ApckTreeRowBase.extend({
    components: {
        'apck-tree-title-row': ApckTreeTitleRow,
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        owaspYear: {
            type: String,
            default: null
        },
        countProp: {
            type: Number,
            default: 0
        },
        criticalProp: {
            type: Number,
            default: 0
        },
        highProp: {
            type: Number,
            default: 0
        },
        mediumProp: {
            type: Number,
            default: 0
        },
        lowProp: {
            type: Number,
            default: 0
        },
        infoProp: {
            type: Number,
            default: 0
        },
        table: {
            type: Object,
            default: null
        },
    },
    data: function() {
        return {
            count: 0,
            critical: 0,
            high: 0,
            medium: 0,
            low: 0,
            info: 0,
            expanded: false,
            rows: [],
        };
    },
    created() {
        this.count = this.countProp;
        this.critical = this.criticalProp;
        this.high = this.highProp;
        this.medium = this.mediumProp;
        this.low = this.lowProp;
        this.info = this.infoProp;
    },
    watch: {
        countProp() {
            this.count = this.countProp;
        },
        criticalProp() {
            this.critical = this.criticalProp;
        },
        highProp() {
            this.high = this.highProp;
        },
        mediumProp() {
            this.medium = this.mediumProp;
        },
        lowProp() {
            this.low = this.lowProp;
        },
        infoProp() {
            this.info = this.infoProp;
        },
    },
    methods: {
        fetch() {
            const cmp = this;
            if (this.table) {
                let params = this.table.buildQueryParams();
                params['owasp'] = this.value;
                params['owasp_year'] = this.owaspYear;
                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }
                AjaxUtils.ajax_get({
                    url: `${cmp.table.apiUrl}/title`,
                    query_params: params,
                    traditional: true,
                    success: (data) => {
                        if (data) {
                            cmp.rows = data.items;
                        }
                    },
                });
            }
        },
        expand() {
            this.expanded = !this.expanded;
            if(this.expanded && this.rows.length === 0) {
                this.fetch();
            }
        },
        deleteRow() {
            const cmp = this;
            console.log(this.table.query);
            if (this.table) {
                const params = this.table.buildQueryParams();
                params['owasp'] = this.value;
                params['owasp_year'] = this.owaspYear;
                if(this.table.results_set_ids !== null) {
                    params['results_set_ids'] = this.table.results_set_ids;
                }
                const queryParams = $.param(params, true);

                const pluralCount = cmp.count > 1 ? `all ${cmp.count}`: 'this';
                const pluralVuln = cmp.count > 1 ? 'vulnerabilities': 'vulnerability';
                cmp.$dialog.confirm(
                    `Are you sure you want to delete ${pluralCount} ${pluralVuln} for OWASP "${cmp.value}"?`,
                    `Delete ${cmp.count} ${pluralVuln}`,
                    function () {
                        deleteVulnerabilities({
                            cmp: cmp,
                            url: `${cmp.table.apiUrl}/delete?${queryParams}`,
                            success_cb: function (resp) {
                                const count = resp.count || 0;
                                const status_counts = resp.status_counts;

                                cmp.count -= count;
                                cmp.cleanupEmptyRow();

                                cmp.$emit('owasp-row-deleted', {owaspRow: cmp, count: count})

                                // reduce status counts
                                Object.entries(status_counts).forEach(([status, val]) => {
                                    cmp.table.status[status] -= val;
                                });
                            }

                        })
                    }
                );
            }
        },
        childRowDeleted({titleRow, count}) {
            this.count -= count;
            this.$data[titleRow.level] -= count;
            this.table.impact[titleRow.level] -= count;

            // If the title row has no vulns, remove it from the list
            if (titleRow.count < 1) {
                const index = this.rows.findIndex(item => {
                    return item.title === titleRow.value && item.impact === titleRow.level;
                });
                if (index !== -1) {
                    this.rows.splice(index, 1);
                }
            }

            // if this owasp row is empty, remove it from the table
            if (this.count < 1) {
                this.cleanupEmptyRow();
            }

            this.$emit('owasp-row-deleted', {owaspRow: this, count: count})
        },
        cleanupEmptyRow() {
            // there are no child vulnerabilities, so we call this to remove the owasp row from the table
            delete this.table.owasp[this.value];
        },
        _buildOwaspParams() {
            const params = this.table.buildQueryParams();
            params['owasp'] = this.value;
            params['owasp_year'] = this.owaspYear;
            if (this.table.results_set_ids !== null) {
                params['results_set_ids'] = this.table.results_set_ids;
            }
            return params;
        },
        bulkAssignUser() {
            const cmp = this;
            const params = cmp._buildOwaspParams();
            let assignee_options = Object.entries(cmp.table.users).map(([key, value]) => ({label: value.name, value: key}));
            assignee_options = [
                {'label': '--- unassigned ---', 'value': null},
                ...assignee_options,
            ];
            cmp.$lightbox.open({
                title: `Set assignee for ${cmp.count} vulnerabilities in OWASP "${cmp.value}"`,
                component: ApckVulnBulkAssigneeForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/assign?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    assignee_options: assignee_options,
                    selected_vulns: [],
                },
                on: {
                    'assignee-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.table.fetchUserCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Assigned user to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'normal',
            });
        },
        bulkSetPriority() {
            const cmp = this;
            const params = cmp._buildOwaspParams();
            cmp.$lightbox.open({
                title: `Set priority for ${cmp.count} vulnerabilities in OWASP "${cmp.value}"`,
                component: ApckVulnBulkPriorityForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/priority?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'priority-updated': (event) => {
                        cmp.table.updateExpandedDatatables();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated priority of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'normal',
            });
        },
        bulkSetStatus() {
            const cmp = this;
            const params = cmp._buildOwaspParams();
            cmp.$lightbox.open({
                title: `Set status for ${cmp.count} vulnerabilities in OWASP "${cmp.value}"`,
                component: ApckVulnBulkStatusForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/status?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'status-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated status of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'normal',
            });
        },
        bulkAddNotes() {
            const cmp = this;
            const params = cmp._buildOwaspParams();
            cmp.$lightbox.open({
                title: `Add notes for ${cmp.count} vulnerabilities in OWASP "${cmp.value}"`,
                component: ApckVulnBulkNotesForm,
                bind: {
                    url: `${cmp.table.apiUrl}/bulk/notes?${$.param(params, true)}`,
                    vuln_count: cmp.count,
                    selected_vulns: [],
                },
                on: {
                    'notes-updated': (event) => {
                        cmp.table.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Added notes to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'normal',
            });
        },
    },
    computed: {
        level() {
            let value = 'info';
            if(this.low > 0) {
                value = 'low';
            }
            if(this.medium > 0) {
                value = 'medium';
            }
            if(this.high > 0) {
                value = 'high';
            }
            if(this.critical > 0) {
                value = 'critical';
            }
            return value;
        }
    },
    template: `
        <li>
            <div class="cell" @click="expand()">
                <a href="javascript:;" class="expander">
                    <i :class="['fa', expanded ? 'fa-caret-down' : 'fa-caret-right']"></i>
                </a>
                <i :class="['fa', 'fa-circle', 'icon', 'severity-icon-' + level]"></i>
                <span class="vuln-group-header">
                    <span class="vuln-group-header-text">{{ value }}</span>
                    <span>( Total: {{ count }} ) -
                        (
                            <b class="severity-icon-critical" v-if="table && table.showCriticalFilter">
                                {{critical}}
                            </b> /
                            <b class="severity-icon-high">
                                {{high}}
                            </b> /
                            <b class="severity-icon-medium">
                                {{medium}}
                            </b> /
                            <b class="severity-icon-low">
                                {{low}}
                            </b> /
                            <b class="severity-icon-info">
                                {{info}}
                            </b>
                        )
                    </span>
                </span>
                <ui-tooltip :class="['actions-tooltip', showTooltip ? 'tooltip-open' : '' ]" placement="left" triggerOnClick @update:open="showTooltip = $event">
                    <template #content>
                        <ui-layout direction="column" gap="1">

                            <ui-button
                                label="Assign user"
                                iconLeft="fa-user"
                                @click.native="bulkAssignUser"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Set priority"
                                iconLeft="fa-sort-amount-desc"
                                @click.native="bulkSetPriority"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Change status"
                                iconLeft="fa-check-circle"
                                @click.native="bulkSetStatus"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Add notes"
                                iconLeft="fa-pen-to-square"
                                @click.native="bulkAddNotes"
                                data-close-tooltip
                            />
                            <ui-button
                                label="Delete"
                                iconLeft="fa-trash"
                                @click.native="deleteRow"
                                data-close-tooltip
                            />
                        </ui-layout>
                    </template>

                    <ui-icon
                        type="secondary"
                        icon="fa-ellipsis-h"
                        size="2xl"
                    />
                </ui-tooltip>
            </div>
            <ul v-if="expanded">
                <apck-tree-title-row
                    v-for="row in rows"
                    :key="row.title + row.impact + row.count"
                    :value="row.title"
                    :level="row.impact"
                    :owasp="value"
                    :owasp-year="owaspYear"
                    :count-prop="row.count"
                    :table="table"
                    @title-row-deleted="childRowDeleted($event)"
                />
            </ul>
        </li>
    `
});

const VulnFilterDisplayCard = {
    props: {
        handler: {
            type: Function
        },
        title: {
            type: String,
            default: ''
        },
        count: {
            type: [Number, null],
            default: null
        },
        value: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'fa-regular fa-square'
        },
        iconCheck: {
            type: String,
            default: 'fa-solid fa-square-check'
        },
        unactiveClass: {
            type: String,
            default: ''
        },
        activeClass: {
            type: String,
            default: 'active'
        }
    },
    data: function() {
        return {
            active_value: this.value
        };
    },
    computed: {
        count_display() {
            if (this.count === null) {
                return '-';
            }
            return this.count;
        }
    },
    watch: {
        value: function(val){
            //After DOM render
            this.$nextTick(function () {
                this.active_value = this.value;
            });
        }
    },
    methods: {
        btnclick: function() {
            this.active_value = !this.active_value;
            this.$emit('input', this.active_value);
            // Black magic, :)
            // basically it allows any arguments to be passed
            if(this.handler) {
                this.handler.apply(arguments);
            }
        }
    },
    template: `
        <a v-bind:class="['btn', 'btn-check', 'vuln-filter-impact-card', active_value ? 'active' : '']"
           v-on:click="btnclick()">
            <input ref="check" type="checkbox" :checked="active_value" autocomplete="off">
            
            <span class="vuln-filter-impact-card-title">
                <i v-if="icon" v-bind:class="['fa', icon]"/>
                {{ title }}
                <i v-bind:class="['fa', active_value ? iconCheck : 'fa-regular fa-square']" class="vuln-filter-impact-card-check"/>
            </span>
            
            <span class="vuln-filter-impact-card-count">{{ count_display }}</span>
            
            
        </a>
    `
}

export const ApckVulnTable = {
    components: {
        'apck-tree-title-row': ApckTreeTitleRow,
        'apck-tree-impact-row': ApckTreeImpactRow,
        'apck-tree-host-row': ApckTreeHostRow,
        'apck-tree-owasp-row': ApckTreeOwaspRow,
        'apck-vuln-filter-impact-card': VulnFilterDisplayCard,
        'apck-gl-filtered-search': ApckGlFilteredSearch,
        'apck-vuln-details': ApckVulnDetails,
    },
    props: {
        src: {
            type: String,
            default: '/vulnerabilities'
        },
        autoload: {
            type: Boolean,
            default: true
        },
        start: {
            type: Number,
            default: 0
        },
        limit: {
            type: Number,
            default: 10
        },
        sort: {
            type: String,
            default: null
        },
        dir: {
            type: String,
            default: null
        },
        results_set_ids: {
            type: Array,
            default: () => []
        },
        report_group_id: {
            type: String,
            default: null
        },
        host: {
            type: String,
            default: null
        },
        assignee: {  // force assignee for this table
            type: String,
            default: null
        },
        showAgentFilter: {
            type: Boolean,
            default: true
        },
        showCriticalFilter: {
            type: Boolean,
            default: true
        },
        showDateFilters: {
            type: Boolean,
            default: true
        },
        showUserFilter: {
            type: Boolean,
            default: true
        },
        showHostFilter: {
            type: Boolean,
            default: true
        },
        initialLastDetectedFrom: {
            type: [String, Date],
            default: ''
        },
        // allow for api url customisation
        apiUrl: {
            type: String,
            default: "/vuln-control"
        },
        // allow for standalone (webgui-prod) override of URLs
        vulnUrl: {
            type: String,
            default: ""
        },
        vulnImportUrl: {
            type: String,
            default: ""
        },
        showImportButton: {
            type: Boolean,
            default: false
        },
        scan_name: {
            type: String,
            default: null
        },
        initialCategory: {
            type: String,
            default: null
        },
    },
    watch: {
        results_set_ids: function(val){
            //After DOM render
            this.$nextTick(() => {
                this.query = this.reset_query;
                this.fetchImpactCounts();
                this.fetchStatusCounts();
                this.fetchCategoryCounts();
                this.fetchUserCounts();
                this.fetchHostCounts();
                this.fetchIPV4Counts();
                this.fetchOWASPCounts();
                this.fetchTitleCounts();
                this.setRouterQueryParams();
            });
        },
        impact: {
            handler: function () {
                // Update the total count. Since totals across all groups will be the same, we can just take it from impact
                let total = 0;
                if (this.query.inc_critical) {
                    total += this.impact.critical;
                }
                if (this.query.inc_high) {
                    total += this.impact.high;
                }
                if (this.query.inc_medium) {
                    total += this.impact.medium;
                }
                if (this.query.inc_low) {
                    total += this.impact.low;
                }
                if (this.query.inc_info) {
                    total += this.impact.info;
                }
                this.filteredVulnCount = total;
            },
            deep: true
        },
        query: {
            handler() {
                // force this.assignee if set
                if (this.assignee) {
                    this.query.assignee_id = this.assignee;
                }
                this.updateCounts();
            },
            deep: true
        },
        changedFilters: {
            handler() {
                this.$data._loadedKey += 1;
            },
            deep: true
        },
        hosts: {
            handler() {
                this.loaded.hosts = true;
            },
            deep: true
        },
        ipv4: {
            handler() {
                this.loaded.ipv4 = true;
            },
            deep: true
        },
        owasp: {
            handler() {
                this.loaded.owasp = true;
            },
            deep: true
        },
        titles: {
            handler() {
                this.loaded.titles = true;
                this.firstLoad = true;
            },
            deep: true
        },
    },
    methods: {
        width: function(width) {
            if(width) {
                return width;
            }
            return 'auto';
        },
        columnType: function(ctype) {
            if(ctype) {
                return 'apck-' + ctype;
            }
            return this.defaultType;
        },
        rowclick: function(rec) {
            if (this.vulnUrl) {
                window.location.href = String.format(this.vulnUrl, rec.get('_id'));
            } else {
                this.$router.push({
                    name: 'vulnerabilities.view',
                    params: {
                        vulnerability_id: rec.get('_id')
                    }
                });
            }
        },
        formatDate: function (date) {
            var cmp = this;
            if (typeof date === 'string' || date instanceof String) {
                return date
            }
            try {
                var tzoffset = date.getTimezoneOffset() * 60000;
                return (new Date(date.getTime() - tzoffset)).toISOString().slice(0, 10);
            } catch (e) {
                if (date !== null) {
                    cmp.$flash({
                        type: 'error',
                        message: "Please enter a valid date in the format YYYY-MM-DD"
                    });
                }
                return '';
            }
        },
        toggleFilters: function() {
            this.showFilters = !this.showFilters;
        },
        toggleBulkActions: function() {
            this.showBulkActions = !this.showBulkActions;
        },
        applyFilters(data) {
            /**
             * Impact selection
             * User selection
             * Host selection
             * Status selection
             */
            if(Object.keys(data).length) {
                let assignee_id = data.assignee_id;
                if(assignee_id) {
                    this.query.assignee_id = assignee_id;
                } else {
                    this.query.assignee_id = this.reset_query.assignee_id;
                }

                Object.keys(data).forEach(key=> {
                    const value = data[key];

                    if (key in this.query) {
                        if (key in data) {
                            this.query[key] = value;
                        } else {
                            this.query[key] = this.reset_query[key];
                        }
                    }

                    if (key === 'hosts') {
                        if (Array.isArray(value)) {
                            this.query.host = value.length === 0 ? ['all'] : value;
                        } else {
                            this.query.host = (!value || value === 'all') ? ['all'] : [value];
                        }
                    } else if (key === 'status') {
                        if (value.length === 0) {
                            this.query.status = this.reset_query.status;
                        } else if (typeof value === 'string') {
                            this.query.status = [value];
                        }
                    } else if (key === 'impact') {
                        this.query.inc_critical = this.showCriticalFilter && value.indexOf('5.0-critical') > -1;
                        this.query.inc_high = value.indexOf('4.0-high') > -1;
                        this.query.inc_medium = value.indexOf('3.0-medium') > -1;
                        this.query.inc_low = value.indexOf('2.0-low') > -1;
                        this.query.inc_info = value.indexOf('1.0-info') > -1;
                    } else if (key === 'filter_search' && value) {
                        let filters = value;
                        if (typeof value === 'string') {
                            const parsedVal = JSON.parse(value);
                            filters = reconstructGitlabFilters(parsedVal['filters']);
                            if (parsedVal['search']) {
                                filters.push(parsedVal['search']);
                            }
                        }
                        this.searchTokensUpdated(filters);
                    }
                });
            }
        },
        fetchStatusCounts() {
            let url = `${this.apiUrl}/status`;
            let params = this.buildQueryParams();
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.status = data;
                    }
                },
            });
        },
        fetchImpactCounts() {
            let url = `${this.apiUrl}/impact`;
            let params = this.buildQueryParams();
            delete params['impact'];
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.impact.critical = 0;
                        if ('critical' in data) {
                            this.impact.critical = data.critical;
                        }
                        this.impact.high = 0;
                        if ('high' in data) {
                            this.impact.high = data.high;
                        }
                        this.impact.medium = 0;
                        if ('medium' in data) {
                            this.impact.medium = data.medium;
                        }
                        this.impact.low = 0;
                        if ('low' in data) {
                            this.impact.low = data.low;
                        }
                        this.impact.info = 0;
                        if ('info' in data) {
                            this.impact.info = data.info;
                        }
                    }
                },
            });
        },
        fetchCategoryCounts() {
            let url = `${this.apiUrl}/type`;
            let params = this.buildQueryParams();
            delete params['category'];
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.category.web_app = data?.web_app || 0;
                        this.category.infra = data?.infra || 0;
                        this.category.agent = data?.agent || 0;

                        this.category.other = 0;
                        let filterNames = ['web_app', 'infra'];
                        if (this.showAgentFilter) {
                            filterNames.push('agent');
                        }
                        for (const [name, count] of Object.entries(data)) {
                            if (!filterNames.includes(name)) {
                                this.category.other += count;
                            }
                        }
                    }
                },
            });
        },
        fetchUserCounts() {
            let url = `${this.apiUrl}/users`;
            let params = this.buildQueryParams();
            // We don't want the assignee to affect the list of users
            delete params['assignee_id'];
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.users = data.users;
                        this.unassigned_users_count = data.unassigned_count;
                    }
                },
            });
        },
        fetchHostListCounts() {
            let url = `${this.apiUrl}/hosts`;
            let params = this.buildQueryParams();
            // We don't want the host to effect the count
            delete params['hosts'];
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.hosts_list = data;
                    }
                },
            });
        },
        fetchHostCounts() {
            const cmp = this;
            let url = `${this.apiUrl}/hosts`;
            let params = this.buildQueryParams();
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.hosts = data;
                        cmp.loaded.hosts = true;
                    }
                },
            });
        },
        fetchIPV4Counts() {
            const cmp = this;
            let url = `${this.apiUrl}/ip_v4`;
            let params = this.buildQueryParams();
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.ipv4 = data;
                        cmp.loaded.ipv4 = true;
                    }
                },
            });
        },
        fetchOWASPCounts() {
            const cmp = this;
            let url = `${this.apiUrl}/owasp`;
            let params = this.buildQueryParams();
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.owasp = data;
                        cmp.loaded.owasp = true;
                    }
                },
            });
        },
        fetchTitleCounts() {
            const cmp = this;
            let url = `${this.apiUrl}/title`;
            let params = this.buildQueryParams();
            if(this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            AjaxUtils.ajax_get({
                url: url,
                query_params: params,
                traditional: true,
                success: (data) => {
                    if (data) {
                        this.titles = data['items'];
                        cmp.loaded.ipv4 = true;
                    }
                },
            });
        },
        fetchUngroupedRows(resetPage = false) {
            if (!this.ungroupedStore) {
                return;
            }
            const params = this.buildQueryParams();
            if (this.results_set_ids !== null) {
                params['results_set_ids'] = this.results_set_ids;
            }
            const store = this.ungroupedStore;
            store.url = `${this.apiUrl}/list`;
            store.sort = this.ungroupedSort.field;
            store.dir = this.ungroupedSort.dir;
            if (resetPage) {
                store.start = 0;
                store.page = 1;
            }
            store.lastParams = Object.assign({}, params, {
                start: store.start,
                limit: store.limit,
                page: store.page,
                sort: store.sort,
                dir: store.dir,
            });
            store.load(store.lastParams);
        },
        updateCounts: debounce(function() {
            // set all loaded to false
             Object.keys(this.loaded).forEach(key => {
                 this.loaded[key] = false;
             });

            this.fetchStatusCounts();
            this.fetchImpactCounts();
            this.fetchCategoryCounts();
            this.fetchUserCounts();
            this.fetchHostCounts();
            if (this.grouping.ungrouped) {
                this.fetchUngroupedRows(true);
            }
            //Could maybe do this better, we use the hosts in the user data
            this.fetchHostListCounts();
            this.fetchIPV4Counts();
            this.fetchOWASPCounts();
            this.fetchTitleCounts();
            this.setRouterQueryParams();
        }, 100),
        toggleGrouping(tabId) {
            let group = tabId.replace('group-by-', '');

            if (group === 'ipv4') {
                group = 'ip_v4'
            }

            for( let key in this.grouping ) {
                if(key === group) {
                    if(this.grouping[group] !== undefined) {
                        this.grouping[group] = !this.grouping[group];
                    }
                } else {
                    this.grouping[key] = false;
                }
            }
            if (group === 'ungrouped' && this.grouping.ungrouped) {
                this.fetchUngroupedRows(true);
            }
        },
        buildQueryParams(){
            let impact = [];
            let status = this.query.status;
            let category = this.query.category;
            let assignee_id = this.query.assignee_id;
            let host = this.query.host;
            let ipv4 = this.query.ipv4;
            let filter_search = this.filter_search;
            let first_detected_start;
            let first_detected_end;
            let last_detected_start;
            let last_detected_end;
            // Impact levels to be included
            if(this.query.inc_critical && this.showCriticalFilter) {
                impact.push('5.0-critical');
            }
            if(this.query.inc_high) {
                impact.push('4.0-high');
            }
            if(this.query.inc_medium) {
                impact.push('3.0-medium');
            }
            if(this.query.inc_low) {
                impact.push('2.0-low');
            }
            if(this.query.inc_info) {
                impact.push('1.0-info');
            }
            // detected dates
            if (this.query.first_detected_start) {
                first_detected_start = this.query.first_detected_start;
            }
            if (this.query.first_detected_end) {
                first_detected_end = this.query.first_detected_end;
            }
            if (this.query.last_detected_start !== null) {
                last_detected_start = this.query.last_detected_start;
            }
            if (this.query.last_detected_end) {
                last_detected_end = this.query.last_detected_end;
            }

            let params = {
                "filter_search": JSON.stringify(parseGitlabFilters(filter_search)),
                "ipv4": ipv4 === 'all' ? [] : [ipv4],
                "impact": impact,
                "status": status.includes('all') ? [] : status,
                "vuln_type": category === 'all' ? [] : [category],
            };

            if (this.showUserFilter) {
                params["assignee_id"] = assignee_id === 'all' ? [] : [assignee_id];
            }
            if (this.showHostFilter) {
                params["hosts"] = (Array.isArray(host) ? host : [host]).includes('all') ? [] : (Array.isArray(host) ? host : [host]);
            }
            if (this.showDateFilters) {
                params["first_detected_start"] = first_detected_start;
                params["first_detected_end"] = first_detected_end;
                params["last_detected_start"] = last_detected_start;
                params["last_detected_end"] = last_detected_end;
            }
            if (this.$route?.query && 'owasp' in this.$route.query && 'owasp_year' in this.$route.query) {
                params["owasp"] = this.$route.query['owasp'];
                params["owasp_year"] = this.$route.query['owasp_year'];
            }
            if (this.report_group_id) {
                params["report_group_id"] = this.report_group_id;
            }

            return params;
        },
        setRouterQueryParams () {
            const params = this.buildQueryParams();
            if (!params["status"].length) {
                params["status"] = ['all']
            }
            this.$router.replace({
                query: {
                    // this is to preserve the existing query parameters
                    ...this.$route?.query || {},
                    ...params
                }
            }).catch(()=>{});
        },
        updateExpandedDatatables() {
            const findExpandedTitleRows = function (el, array = []) {
                if (el.$options && el.$options._componentTag === "apck-tree-title-row" && el.expanded) {
                    array.push(el);
                }
                for (const child of el.$children) {
                    findExpandedTitleRows(child, array);
                }
                return array;
            }

            const titleRows = findExpandedTitleRows(this);
            for (const titleRow of titleRows) {
                titleRow.fetch();
            }
        },
        bulkAssignUser() {
            const cmp = this;
            const params = this.buildQueryParams();
            if(cmp.results_set_ids !== null) {
                params['results_set_ids'] = cmp.results_set_ids;
            }
            let assignee_options = Object.entries(cmp.users).map(([key, value]) => ({label: value.name, value: key}))
            assignee_options = [
                {'label': '--- unassigned ---', 'value': null},
                ...assignee_options,
            ];
            const vulnCount = cmp.selectedVulns.length ? cmp.selectedVulns.length : cmp.filteredVulnCount;
            cmp.$modal.open({
                title: `Set assignee for ${vulnCount} ${cmp.selectedVulns.length ? 'selected' : 'filtered'} vulnerabilities`,
                component: ApckVulnBulkAssigneeForm,
                bind: {
                    url: `${cmp.apiUrl}/bulk/assign?${$.param(params, true)}`,
                    vuln_count: vulnCount,
                    assignee_options: assignee_options,
                    selected_vulns: cmp.selectedVulns
                },
                on: {
                    'assignee-updated': (event) => {
                        cmp.updateExpandedDatatables();
                        cmp.fetchUserCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Assigned user to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            })
        },
        bulkSetPriority() {
            const cmp = this;
            const params = this.buildQueryParams();
            if(cmp.results_set_ids !== null) {
                params['results_set_ids'] = cmp.results_set_ids;
            }
            const vulnCount = cmp.selectedVulns.length ? cmp.selectedVulns.length : cmp.filteredVulnCount;
            cmp.$modal.open({
                title: `Set priority for ${vulnCount} ${cmp.selectedVulns.length ? 'selected' : 'filtered'} vulnerabilities`,
                component: ApckVulnBulkPriorityForm,
                bind: {
                    url: `${cmp.apiUrl}/bulk/priority?${$.param(params, true)}`,
                    vuln_count: vulnCount,
                    selected_vulns: cmp.selectedVulns
                },
                on: {
                    'priority-updated': (event) => {
                        cmp.updateExpandedDatatables();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated priority of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            })
        },
        bulkSetStatus() {
            const cmp = this;
            const params = this.buildQueryParams();
            if(cmp.results_set_ids !== null) {
                params['results_set_ids'] = cmp.results_set_ids;
            }
            const vulnCount = cmp.selectedVulns.length ? cmp.selectedVulns.length : cmp.filteredVulnCount;
            cmp.$modal.open({
                title: `Set status for ${vulnCount} ${cmp.selectedVulns.length ? 'selected' : 'filtered'} vulnerabilities`,
                component: ApckVulnBulkStatusForm,
                bind: {
                    url: `${cmp.apiUrl}/bulk/status?${$.param(params, true)}`,
                    vuln_count: vulnCount,
                    selected_vulns: cmp.selectedVulns
                },
                on: {
                    'status-updated': (event) => {
                        cmp.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Updated status of ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            })
        },
        bulkAddNotes() {
            const cmp = this;
            const params = this.buildQueryParams();
            if(cmp.results_set_ids !== null) {
                params['results_set_ids'] = cmp.results_set_ids;
            }
            const vulnCount = cmp.selectedVulns.length ? cmp.selectedVulns.length : cmp.filteredVulnCount;
            cmp.$modal.open({
                title: `Add notes  for ${vulnCount} ${cmp.selectedVulns.length ? 'selected' : 'filtered'} vulnerabilities`,
                component: ApckVulnBulkNotesForm,
                bind: {
                    url: `${cmp.apiUrl}/bulk/notes?${$.param(params, true)}`,
                    vuln_count: vulnCount,
                    selected_vulns: cmp.selectedVulns
                },
                on: {
                    'notes-updated': (event) => {
                        cmp.updateCounts();
                        cmp.$flash({
                            type: 'success',
                            message: `Added notes to ${event.count || 0} vulnerabilities`,
                        });
                    },
                },
                size: 'md',
            })
        },
        refresh() {
            this.updateCounts();
        },
        serializeFilters(additionalQueryFilters) {
            const filters = Object.assign({}, this.query, additionalQueryFilters || {});
            filters['filter_search'] = this.filter_search || null;
            return filters;
        },
        saveSearch(additionalQueryFilters) {
            const cmp = this;
            var errors = {};
            const serialized_filters = cmp.serializeFilters(additionalQueryFilters);
            const lightbox_conf = {
                title: 'Save vulnerability search filters',
                component: ApckVulnSearchSaveModal,
                bind: {
                    url: `${cmp.apiUrl}/filters/save`,
                    table: cmp,
                    serializedFilters: serialized_filters,
                    errors: errors,
                },
                on: {
                    updateErrors: (err) => {
                        // clear old keys
                        Object.keys(errors).forEach(key => {
                            Vue.delete(errors, key);
                        });
                        // set new keys
                        Object.assign(errors, err);
                    },
                    saved: (filterName) => {
                        cmp.lastLoadedFilterName = filterName;
                        cmp.lastLoadedFilters = serialized_filters;
                    }
                },
                size: 'md',
            };
            cmp.$modal.open(lightbox_conf);
        },
        loadSearch() {
            const cmp = this;
            cmp.$modal.open({
                title: 'Load saved search filters',
                component: ApckVulnSearchSelectModal,
                bind: {
                    url: `${cmp.apiUrl}/filters`,
                    table: cmp,
                },
                on: {
                    loadedFilters: (loadedFilters, filterName) => {
                        cmp.applyFilters(loadedFilters);
                        cmp.lastLoadedFilters = loadedFilters;
                        cmp.lastLoadedFilterName = filterName;
                    }
                },
                size: 'sm',
            })
        },
        newFiltersWindow() {
            const cmp = this;

            cmp.$modal.open({
                title: 'Filters',
                component: ApckVulnFilters,
                bind: {
                    table: cmp,
                },
                size: 'sm',
            });
        },
        titleRowDeleted({titleRow, count}) {
            // reduce impact count
            this.impact[titleRow.level] -= count;

            this.fetchIPV4Counts();
            this.fetchOWASPCounts();
            this.fetchHostCounts();
            this.fetchHostListCounts();
        },
        ungroupedRowDeleted(count) {
            this.filteredVulnCount -= count;
            this.fetchImpactCounts();
            this.fetchStatusCounts();
            this.fetchHostCounts();
            this.fetchHostListCounts();
            this.fetchIPV4Counts();
            this.fetchOWASPCounts();
        },
        impactRowDeleted({impactRow, count}) {
            this.filteredVulnCount -= count;
            this.impact[impactRow.level] -= count;

            // update host and ip counts
            if (impactRow.count < 1) {
                // if we're deleting all vulns with a certain impact, we can set the impact counts for it to 0
                const recountHostRows = function (arr) {
                    Object.entries(arr).forEach(([item, counts]) => {
                        const num_deleted = counts[impactRow.level];
                        arr[item][impactRow.level] = 0;
                        arr[item].total = counts.total - num_deleted;
                        if (arr[item].total < 1) {
                            delete arr[item];
                        }
                    })
                }

                recountHostRows(this.hosts);
                recountHostRows(this.hosts_list);
                recountHostRows(this.ipv4);
            } else {
                this.fetchHostCounts();
                this.fetchHostListCounts();
                this.fetchIPV4Counts();
                this.fetchOWASPCounts();
            }
        },
        owaspRowDeleted({owaspRow, count}) {
            this.filteredVulnCount -= count;
            this.fetchTitleCounts();
            this.fetchOWASPCounts();
            if (owaspRow.count < 1) {
                this.impact = {
                    'critical': this.impact.critical - owaspRow.critical,
                    'high': this.impact.high - owaspRow.high,
                    'medium': this.impact.medium - owaspRow.medium,
                    'low': this.impact.low - owaspRow.low,
                    'info': this.impact.info - owaspRow.info
                };
                if (!this.showCriticalFilter) {
                    delete this.impact['critical'];
                }
            }
        },
        hostRowDeleted({hostRow, count}) {
            this.filteredVulnCount -= count;

            this.fetchTitleCounts();

            // update count in hosts dropdown
            if (hostRow.is_ipv4) {
                this.fetchHostCounts();
                this.fetchHostListCounts();
            } else {
                this.fetchIPV4Counts();
                this.hosts_list[hostRow.value] = {
                    'critical': hostRow.critical,
                    'high': hostRow.high,
                    'medium': hostRow.medium,
                    'low': hostRow.low,
                    'info': hostRow.info,
                    'total': hostRow.count
                }
                if (!this.showCriticalFilter) {
                    delete this.hosts_list[hostRow.value]['critical'];
                }
            }

            if (hostRow.count < 1) {
                if (!hostRow.is_ipv4) {
                    delete this.hosts_list[hostRow.value];
                }
                // reduce impact counts
                this.impact = {
                    'critical': this.impact.critical - hostRow.critical,
                    'high': this.impact.high - hostRow.high,
                    'medium': this.impact.medium - hostRow.medium,
                    'low': this.impact.low - hostRow.low,
                    'info': this.impact.info - hostRow.info
                }
                if (!this.showCriticalFilter) {
                    delete this.impact['critical'];
                }
            }
        },
        generateReportWindow() {
            const cmp = this;

            cmp.$modal.open({
                title: "Vulnerabilities Report",
                component: ApckVulnReportRollout,
                bind: {
                    table: cmp,
                },
                size: 'md',
            });
        },
        importVulns() {
            const cmp = this;
            var errors = {};
            const lightbox_conf = {
                title: 'Import vulnerabilities from file',
                component: ApckVulnImportModal,
                bind: {
                    url: cmp.vulnImportUrl,
                    loaded_results_sets: cmp.results_set_ids,
                    errors: errors
                },
                on: {
                    vulnsImported: () => {
                        cmp.updateCounts();
                    },
                    updateErrors: (err) => {
                        // clear old keys
                        Object.keys(errors).forEach(key => {
                            Vue.delete(errors, key);
                        });
                        // set new keys
                        Object.assign(errors, err);
                    }
                },
                size: 'md',
            };
            cmp.$modal.open(lightbox_conf);
        },
        filterSearch() {
            this.updateCounts();
        },
        displayError(data) {
            console.error('Filter search error!', data)
        },
        searchTokensUpdated(newTokens) {
            this.filter_search = newTokens;
            if (JSON.stringify(this._oldSearchTokens) !== JSON.stringify(this.filter_search)) {
                this.updateCounts();
            }
            this._oldSearchTokens = this.filter_search;
        },
        registerFilter(name, data_key, default_value, evt) {
            // data_key can be a string for simple getting/setting of a data value.
            // It can also be an array containing getter and setter function callbacks for more control. The
            // getter/setter functions take the component instance and the registered filter object below as args.
            // The getter should return false if the value is unchanged, otherwise the text to display on the filter.
            // The setter is responsible for resetting the state of the filter when it is cleared.
            this.$data._registeredFilters.push({
                name,
                data_key,
                default_value
            });
        },
        clearAllFilters() {
            for (const filter in this.changedFilters) {
                this.clearFilter(filter);
            }
        },
        clearFilter(filter_name) {
            const registered_filter = this.$data._registeredFilters.filter((f) => f.name === filter_name)[0];
            if (Array.isArray(registered_filter.data_key)) {
                // use the setter function to set the data
                registered_filter.data_key[1](this, registered_filter);
            } else {
                set(this.$data, registered_filter.data_key, registered_filter.default_value);
            }
        },
        selectRow(row) {
            const set = new Set(this.selectedVulns);
            set.add(row._id);
            this.selectedVulns = Array.from(set);
        },
        deselectRow(row) {
            const set = new Set(this.selectedVulns);
            set.delete(row._id);
            this.selectedVulns = Array.from(set);
        },
        setHostSort(field) {
            if (this.hostSort.field === field) {
                this.hostSort.dir = this.hostSort.dir === 'asc' ? 'desc' : 'asc';
            } else {
                this.hostSort.field = field;
                this.hostSort.dir = field === 'impact' ? 'desc' : 'asc';
            }
        },
        setUngroupedSort(field) {
            if (this.ungroupedSort.field === field) {
                this.ungroupedSort.dir = this.ungroupedSort.dir === 'asc' ? 'desc' : 'asc';
            } else {
                this.ungroupedSort.field = field;
                this.ungroupedSort.dir = (field === 'impact' || field === 'last_detected_at') ? 'desc' : 'asc';
            }
            this.fetchUngroupedRows(true);
        },
    },
    computed: {
        impactLevels: function() {
            let impact = [];
            if(this.query.inc_critical) {
                impact.push('critical');
            }
            if(this.query.inc_high) {
                impact.push('high');
            }
            if(this.query.inc_medium) {
                impact.push('medium');
            }
            if(this.query.inc_low) {
                impact.push('low');
            }
            if(this.query.inc_info) {
                impact.push('info');
            }

            return impact;
        },
        status_total() {
            return Object.values(this.status).reduce((acc, count) => acc + count, 0);
        },
        category_total() {
            return Object.values(this.category).reduce((acc, count) => acc + count, 0);
        },
        hosts_total() {
            return Object.values(this.hosts_list).reduce((acc, host) => acc + host.total, 0);
        },
        users_total() {
            return Object.values(this.users).reduce((acc, user) => acc + user.count, 0) + this.unassigned_users_count;
        },
        category_count() {
            if (this.query.category === 'web_app') {
                return this.category.web_app;
            } else if (this.query.category === 'infra') {
                return this.category.infra;
            } else if (this.query.category === 'agent') {
                return this.category.agent;
            } else if (this.query.category === 'other') {
                return this.category.other;
            } else if (this.query.category === 'all') {
                return this.category_total;
            }
        },
        category_options() {
            let categories = [
                {'label': `All Categories (${this.category_total})`, 'value': 'all'},
                {'label': `Web App (${this.category.web_app})`, 'value': 'web_app'},
                {'label': `Infrastructure (${this.category.infra})`, 'value': 'infra'},
                {'label': `Agent (${this.category.agent})`, 'value': 'agent'},
                {'label': `Other (${this.category.other})`, 'value': 'other'},
            ];
            if (!this.showAgentFilter) {
                categories = categories.filter(item => item.value !== 'agent');
            }
            return categories;
        },
        status_options() {
            return [
                {'label': `Any Status (${this.status_total})`, 'value': 'all'},
                {'label': `Unfixed (${this.status.unfixed})`, 'value': 'unfixed'},
                {'label': `False Positive (${this.status.false_positive})`, 'value': 'false_positive'},
                {'label': `Acceptable Risk (${this.status.acceptable_risk})`, 'value': 'acceptable_risk'},
                {'label': `Backported (${this.status.backported || 0})`, 'value': 'backported'},
                {'label': `Investigating (${this.status.investigating || 0})`, 'value': 'investigating'},
                {'label': `Fixed (${this.status.fixed})`, 'value': 'fixed'}
            ];
        },
        host_options() {
            return [
                {'label': `All Hosts (${this.hosts_total})`, 'value': 'all'},
                ...Object.entries(this.hosts_list).map(([_host, data]) => ({
                    'label': `${_host} (${data.total})`,
                    'value': _host
                }))
            ];
        },
        assignee_options() {
            return [
                {'label': `All Users (${this.users_total})`, 'value': 'all'},
                {'label': `Unassigned (${this.unassigned_users_count})`, 'value': 'null'},
                ...Object.entries(this.users).map(([id, user]) => ({
                    'label': `${user.name} (${user.count})`,
                    'value': id
                }))
            ];
        },
        changedFilters() {
            // returns all the "active" filters - that is, filters that do not currently have their default state
            const cmp = this;
            const activeFilters = {};

            for (const f of this.$data._registeredFilters) {
                let changed_value = false;
                if (Array.isArray(f.data_key)) {
                    // use the getter function to determine if the value has changed. This will be false, or a string
                    changed_value = f.data_key[0](cmp, f);
                } else {
                    const current_value = get(cmp.$data, f.data_key);
                    if (current_value !== f.default_value) {
                        changed_value = current_value;
                    }
                }

                if (changed_value) {
                    activeFilters[f.name] = changed_value;
                }
            }
            return activeFilters;
        },
        category_getter_setter() {
            return [
                (cmp, registeredFilter) => {
                    if (cmp.query.category !== registeredFilter.default_value) {
                        // convert value to label, and strip count from the end
                        const label = cmp.category_options.find(item => item.value === cmp.query.category)?.label;
                        if (!label) return null;

                        const index = label.lastIndexOf(" (");
                        return index !== -1 ? label.slice(0, index) : label;
                    }
                    return false;
                },
                (cmp, registeredFilter) => {
                    cmp.query.category = registeredFilter.default_value;
                }
            ]
        },
        assignee_getter_setter() {
            return [
                (cmp, registeredFilter) => {
                    if (cmp.query.assignee_id !== registeredFilter.default_value) {
                        // convert value to label, and strip count from the end
                        const label = cmp.assignee_options.find(item => item.value === cmp.query.assignee_id)?.label;
                        if (!label) return null;

                        const index = label.lastIndexOf(" (");
                        return index !== -1 ? label.slice(0, index) : label;
                    }
                    return false;
                },
                (cmp, registeredFilter) => {
                    cmp.query.assignee_id = registeredFilter.default_value;
                }
            ]
        },
        status_getter_setter() {
            return [
                // returns the filter string if the value is changed
                (cmp, registeredFilter) => {
                    if (!isEqual(cmp.query.status, registeredFilter.default_value)) {
                        const labels = cmp.query.status.map(value => {
                            // convert value to label, and strip count from the end
                            const label = cmp.status_options.find(item => item.value === value)?.label;
                            if (!label) return null;

                            const index = label.lastIndexOf(" (");
                            return index !== -1 ? label.slice(0, index) : label;
                            }
                        );
                        return labels.join(', ');
                    }
                    return false;
                },
                // clears the filter value and restores to default
                (cmp, registeredFilter) => {
                    cmp.query.status = registeredFilter.default_value;
                }
            ]
        },
        first_detected_getter_setter() {
            return [
                (cmp, registeredFilter) => {
                    const from = cmp.query.first_detected_start;
                    const to = cmp.query.first_detected_end;

                    if (from !== '' || to !== '') {
                        if (from && to) {
                            return `${from} to ${to}`;
                        } else if (from) {
                            return `${from} to -`;
                        } else if (to) {
                            return `- to ${to}`;
                        }
                    }
                    return false;
                },
                (cmp, registeredFilter) => {
                    cmp.query.first_detected_start = '';
                    cmp.query.first_detected_end = '';
                }
            ]
        },
        last_detected_getter_setter() {
            return [
                (cmp, registeredFilter) => {
                    const from = cmp.query.last_detected_start;
                    const to = cmp.query.last_detected_end;

                    if (from !== '' || to !== '') {
                        if (from && to) {
                            return `${from} to ${to}`;
                        } else if (from) {
                            return `${from} to -`;
                        } else if (to) {
                            return `- to ${to}`;
                        }
                    }
                },
                (cmp, registeredFilter) => {
                    cmp.query.last_detected_start = '';
                    cmp.query.last_detected_end = '';
                }
            ]
        },
        host_getter_setter() {
            return [
                (cmp, registeredFilter) => {
                    const host = cmp.query.host;
                    const hostArr = Array.isArray(host) ? host : [host];
                    if (!isEqual(hostArr, registeredFilter.default_value) && !hostArr.includes('all')) {
                        return hostArr.join(', ');
                    }
                    return false;
                },
                (cmp, registeredFilter) => {
                    cmp.query.host = registeredFilter.default_value;
                }
            ]
        },
        loadedFiltersChanged() {
            return !isEqual(this.lastLoadedFilters, this.serializeFilters());
        },
        _hostImpactScore() {
            return (data) => {
                if (data.critical > 0) return 5;
                if (data.high > 0) return 4;
                if (data.medium > 0) return 3;
                if (data.low > 0) return 2;
                return 1;
            };
        },
        sortedHosts() {
            const score = this._hostImpactScore;
            return Object.entries(this.hosts)
                .map(([host, data]) => ({ host, data }))
                .sort((a, b) => {
                    if (this.hostSort.field === 'impact') {
                        const diff = score(b.data) - score(a.data);
                        return this.hostSort.dir === 'desc' ? diff : -diff;
                    } else {
                        const diff = a.host.localeCompare(b.host);
                        return this.hostSort.dir === 'asc' ? diff : -diff;
                    }
                });
        },
        sortedIPv4() {
            const score = this._hostImpactScore;
            return Object.entries(this.ipv4)
                .map(([host, data]) => ({ host, data }))
                .sort((a, b) => {
                    if (this.hostSort.field === 'impact') {
                        const diff = score(b.data) - score(a.data);
                        return this.hostSort.dir === 'desc' ? diff : -diff;
                    } else {
                        const diff = a.host.localeCompare(b.host);
                        return this.hostSort.dir === 'asc' ? diff : -diff;
                    }
                });
        },
        owaspYear: function() {
            return "2025";
        },
        owaspTitle() {
            return `OWASP Top 10 ${this.owaspYear}`;
        },
        hasOwasp() {
            return Object.keys(this.owasp).length > 0;
        },
        sortedOwasp() {
            const score = this._hostImpactScore;
            return Object.entries(this.owasp)
                .map(([owaspName, data]) => ({ owaspName, data }))
                .sort((a, b) => {
                    if (this.hostSort.field === 'impact') {
                        const diff = score(b.data) - score(a.data);
                        return this.hostSort.dir === 'desc' ? diff : -diff;
                    } else {
                        const diff = a.owaspName.localeCompare(b.owaspName);
                        return this.hostSort.dir === 'asc' ? diff : -diff;
                    }
                });
        },
        impactBoxes() {
            const severityLevels = [
                {
                    level: '4',
                    label: 'High',
                    icon: 'fa-chevrons-up',
                    class: 'severity-icon-high',
                    color: 'orange',
                    queryKey: 'inc_high',
                    impactKey: 'high'
                },
                {
                    level: '3',
                    label: 'Medium',
                    icon: 'fa-bug',
                    class: 'severity-icon-medium',
                    color: 'yellow',
                    queryKey: 'inc_medium',
                    impactKey: 'medium'
                },
                {
                    level: '2',
                    label: 'Low',
                    icon: 'fa-chevrons-down',
                    class: 'severity-icon-low',
                    color: 'green',
                    queryKey: 'inc_low',
                    impactKey: 'low'
                },
                {
                    level: '1',
                    label: 'Info',
                    icon: 'fa-circle-info',
                    class: 'severity-icon-info',
                    color: 'blue',
                    queryKey: 'inc_info',
                    impactKey: 'info'
                }
            ];

            const boxes = [];

            if (this.showCriticalFilter) {
                boxes.push({
                    level: '5',
                    label: 'Critical',
                    icon: 'fa-triangle-exclamation',
                    class: 'severity-icon-critical',
                    color: 'red',
                    disabled: !this.query.inc_critical,
                    value: this.impact.critical,
                    iconType: COLOR_TO_TYPE['red'],
                    handler: () => {
                        this.query.inc_critical = !this.query.inc_critical;
                    }
                });
            }

            severityLevels.forEach(severity => {
                boxes.push({
                    level: severity.level,
                    label: severity.label,
                    icon: severity.icon,
                    class: severity.class,
                    color: severity.color,
                    disabled: !this.query[severity.queryKey],
                    value: this.impact[severity.impactKey],
                    iconType: COLOR_TO_TYPE[severity.color],
                    handler: () => {
                        this.query[severity.queryKey] = !this.query[severity.queryKey];
                    }
                });
            });

            return boxes;
        },
        isLoading() {
            return !this.firstLoad || Object.keys(this.loaded).some(k => !this.loaded[k])
        }
    },
    mounted: function() {
        // Get the parameters needed to populate the filters.
        // When a results_set_ids constraint is active (scan results page), strip any stale
        // date filters from the route - they originate from a previous all-vulns page visit
        // and would wrongly exclude vulns detected outside the 30-day window.
        if (this.results_set_ids && this.results_set_ids.length) {
            const routeQuery = Object.assign({}, this.$route.query);
            delete routeQuery.last_detected_start;
            delete routeQuery.last_detected_end;
            delete routeQuery.first_detected_start;
            delete routeQuery.first_detected_end;
            this.applyFilters(routeQuery);
        } else {
            this.applyFilters(this.$route.query);
        }

        // Apply initial category if provided via prop
        if (this.initialCategory) {
            this.query.category = this.initialCategory;
        }

        // Register filters for active filter indicators
        this.registerFilter('Assigned User', this.assignee_getter_setter, 'all');
        this.registerFilter('Status', this.status_getter_setter, ['all']);
        this.registerFilter('Hosts', this.host_getter_setter, ['all']);
        this.registerFilter('First Detected', this.first_detected_getter_setter, '');
        this.registerFilter('Last Detected', this.last_detected_getter_setter, '');

        // Server-side paginated store for the flat (ungrouped) view.
        const cmp = this;
        const store = new Store({
            url: `${this.apiUrl}/list`,
            method: 'get',
            autoLoad: false,
            page: 1,
            limit: 50,
            sort: this.ungroupedSort.field,
            dir: this.ungroupedSort.dir,
        });
        store.on('beforeload', function() {
            cmp.loadingUngrouped = true;
        });
        store.on('load', function(s, data) {
            cmp.ungroupedRows = (data && data.items) ? data.items : [];
            cmp.loadingUngrouped = false;
        });
        store.on('errorload', function() {
            cmp.ungroupedRows = [];
            cmp.loadingUngrouped = false;
        });
        this.ungroupedStore = store;

        // Run all the queries to build the data sources.
        this.updateCounts();
    },
    data: function() {
        var cmp = this;
        return {
            vuln_table: cmp,
            firstLoad: false,
            loaded: {
                titles: true,
                hosts: true,
                ipv4: true
            },
            reportGenerationProgress: {},
            filteredVulnCount: 0,
            ungroupedRows: [],
            loadingUngrouped: false,
            ungroupedSort: {
                field: 'impact',
                dir: 'desc',
            },
            ungroupedStore: null,
            actions: null,
            showFilters: true,
            showBulkActions: true,
            grouping: {
                ungrouped: false,
                impact: true,
                hostname: false,
                ip_v4: false
            },
            hostSort: {
                field: 'impact',
                dir: 'desc',
            },
            impact: {
                critical: 0,
                high: 0,
                medium: 0,
                low: 0,
                info: 0
            },
            status: {
                acceptable_risk: 0,
                unfixed: 0,
                fixed: 0,
                false_positive: 0
            },
            category: {
                web_app: 0,
                infra: 0,
                agent: 0,
                other: 0,
            },
            unassigned_users_count: 0,
            users: {},
            hosts_list: {},
            hosts: {},
            ipv4: {},
            owasp: {},
            titles: [],
            selectedVulns: [],
            reset_query: {
                inc_critical: cmp.showCriticalFilter,
                inc_high: true,
                inc_medium: true,
                inc_low: true,
                inc_info: true,

                category: 'all',
                assignee_id: 'all',
                status: ['unfixed', 'investigating'],
                host: ['all'],
                ipv4: 'all',

                first_detected_start: '',
                first_detected_end: '',
                last_detected_start: cmp.formatDate(cmp.initialLastDetectedFrom),
                last_detected_end: '',
            },
            query: {
                inc_critical: cmp.showCriticalFilter,
                inc_high: true,
                inc_medium: true,
                inc_low: true,
                inc_info: true,

                category: 'all',
                assignee_id: 'all',
                status: ['unfixed', 'investigating'],
                host: ['all'],
                ipv4: 'all',

                first_detected_start: '',
                first_detected_end: '',
                last_detected_start: cmp.formatDate(cmp.initialLastDetectedFrom),
                last_detected_end: '',
            },
            _registeredFilters: [],
            filter_search: [],
            filter_tokens: [
                {
                    id: 'token-1',
                    type: 'title',
                    icon: 'title',
                    title: 'Title',
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                    operators: [
                        {value: '=', description: 'is', default: 'true'},
                        {value: '!=', description: 'is not'},
                        {value: '∈', description: 'contains'},
                        {value: '∉', description: 'does not contain'},
                        {value: '^=', description: 'starts with'},
                        {value: '!^=', description: 'does not start with'},
                        {value: '=$', description: 'ends with'},
                        {value: '!=$', description: 'does not end with'},
                    ],
                },
                {
                    id: 'token-2',
                    type: 'cvss_v3_base_score',
                    icon: 'star-o',
                    title: 'CVSS V3 Score',
                    operators: [
                        {value: '=', description: 'is', default: 'true', allowEmpty: true},
                        {value: '!=', description: 'is not'},
                        {value: '>', description: 'is greater than'},
                        {value: '<', description: 'is smaller than'},
                        {value: '>=', description: 'is greater or equal to'},
                        {value: '<=', description: 'is smaller or equal to'},
                    ],
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                },
                {
                    id: 'token-3',
                    type: 'cvss_base_score',
                    icon: 'star-o',
                    title: 'CVSS V2 Score',
                    operators: [
                        {value: '=', description: 'is', default: 'true', allowEmpty: true},
                        {value: '!=', description: 'is not'},
                        {value: '>', description: 'is greater than'},
                        {value: '<', description: 'is smaller than'},
                        {value: '>=', description: 'is greater or equal to'},
                        {value: '<=', description: 'is smaller or equal to'},
                    ],
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                },
                {
                    id: 'token-4',
                    type: 'attack',
                    icon: 'star-o',
                    title: 'Attack URL',
                    operators: [
                        {value: '=', description: 'is', default: 'true', allowEmpty: true},
                        {value: '!=', description: 'is not'},
                        {value: '∈', description: 'contains'},
                        {value: '∉', description: 'does not contain'},
                        {value: '^=', description: 'starts with'},
                        {value: '!^=', description: 'does not start with'},
                        {value: '=$', description: 'ends with'},
                        {value: '!=$', description: 'does not end with'},
                    ],
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                },
                {
                    id: 'token-5',
                    type: 'port',
                    icon: 'star-o',
                    title: 'Port',
                    operators: [
                        {value: '=', description: 'is', default: 'true', allowEmpty: true},
                        {value: '!=', description: 'is not'},
                        {value: '>', description: 'is greater than'},
                        {value: '<', description: 'is smaller than'},
                        {value: '>=', description: 'is greater or equal to'},
                        {value: '<=', description: 'is smaller or equal to'},
                    ],
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                },
                {
                    id: 'token-6',
                    type: 'parameter',
                    icon: 'star-o',
                    title: 'Affected Parameter',
                    operators: [
                        {value: '=', description: 'is', default: 'true', allowEmpty: true},
                        {value: '!=', description: 'is not'},
                        {value: '∈', description: 'contains'},
                        {value: '∉', description: 'does not contain'},
                        {value: '^=', description: 'starts with'},
                        {value: '!^=', description: 'does not start with'},
                        {value: '=$', description: 'ends with'},
                        {value: '!=$', description: 'does not end with'},
                    ],
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                },
                {
                    id: 'token-7',
                    type: 'target',
                    icon: 'star-o',
                    title: 'Target',
                    operators: [
                        {value: '=', description: 'is', default: 'true', allowEmpty: true},
                        {value: '!=', description: 'is not'},
                        {value: '∈', description: 'contains'},
                        {value: '∉', description: 'does not contain'},
                        {value: '^=', description: 'starts with'},
                        {value: '!^=', description: 'does not start with'},
                        {value: '=$', description: 'ends with'},
                        {value: '!=$', description: 'does not end with'},
                    ],
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                },
                {
                    id: 'token-8',
                    type: '_id',
                    icon: 'hash',
                    title: 'ID',
                    showFriendlyText: true,
                    token: ApckGlFilteredSearchToken,
                    operators: [
                        {value: '=', description: 'is', default: 'true'},
                    ],
                },
            ],
            lastLoadedFilterName: '',
            lastLoadedFilters: '',
            _loadedKey: 0
        };
    },
    template: `
        <div class="new-ui apck-vue-vuln-table">
            <ui-layout direction="column">
    
                <ui-layout class="vuln-filters-top" align="start" justify="start">
                    <ui-dropdown-select
                        :modelValue="query.category"
                        @update:modelValue="query.category = $event"
                        :options="category_options"
                    />
                    
                    <apck-gl-filtered-search
                        v-bind:class="['search']"
                        :available-tokens="filter_tokens"
                        :value="filter_search"
                        :termsAsTokens="true"
                        clearButtonTitle=""
                        placeholder="Search..."
                        @submit="filterSearch"
                        @displayError="displayError"
                        @tokensUpdated="searchTokensUpdated($event);"
                        :updateSuggestionsPositionOnScroll="true"
                    />
    
                    <ui-button
                        iconLeft="fa-filter"
                        label="New Filters"
                        value="New Filters"
                        @click="newFiltersWindow"
                    />
                    
                    <ui-button
                        iconLeft="fa-arrow-up-from-bracket"
                        label="Load Filters"
                        value="Load Filters" 
                        type="outline"
                        @click="loadSearch"
                    />
                    
                    <ui-button
                        id="generateReportBtn"
                        iconLeft="fa-file-arrow-down"
                        label="Generate Report"
                        value="Generate Report"
                        type="outline"
                        @click="generateReportWindow"
                    />
                </ui-layout>
    
                <ui-panel-group-data-list
                    v-if="showFilters"
                    :data="impactBoxes"
                    :loading="false"
                    layout="grid"
                    cols="5"
                    gap="2"
                    counter
                />
                
                <transition name="short-slide-down" appear>
                    <ui-layout v-if="Object.keys(changedFilters).length" gap="2" align="center">
                        <ui-heading>Filters:</ui-heading>
        
                        <ui-layout gap="2" wrap>
                            <transition-group
                                name="short-slide-right"
                                tag="ul"
                                class="contents"
                            >
                                <li v-for="(value, name) in changedFilters" :key="name + value">
                                    <ui-button
                                        :label="name + ': ' + value"
                                        iconRight="fa-xmark"
                                        type="outline"
                                        @click="clearFilter(name)"
                                    />
                                </li>
                            </transition-group>
                        </ui-layout>
        
                        <ui-button
                            label="Clear all"
                            color="red"
                            type="ghost"
                            @click="clearAllFilters()"
                        />
                    </ui-layout>
                </transition>
                
                <ui-tabs
                    @update:activeTabId="toggleGrouping($event)"
                    initialActiveTab="Group by Impact"
                    :loading="isLoading"
                    noInnerPanel
                >
                    <template #toolbar>
                        <div v-show="showBulkActions" class="bulk-actions">
                            <div>
                                <span v-if="selectedVulns.length">Apply to {{ selectedVulns.length }} selected vulnerabilities:</span>
                                <span v-else>Apply to {{ filteredVulnCount }} filtered vulnerabilities:</span>
                                <ui-button
                                    label="Assign user"
                                    iconLeft="fa-user"
                                    type="outline"
                                    @click="bulkAssignUser"
                                />
    
                                <ui-button
                                    label="Set priority"
                                    iconLeft="fa-sort-amount-desc"
                                    type="outline"
                                    @click="bulkSetPriority"
                                />
    
                                <ui-button
                                    label="Change Status"
                                    iconLeft="fa-check-circle"
                                    type="outline"
                                    @click="bulkSetStatus"
                                />
    
                                <ui-button
                                    label="Add notes"
                                    iconLeft="fa-pen-to-square"
                                    type="outline"
                                    @click="bulkAddNotes"
                                />
                            </div>
                            
                            <div v-if="grouping.hostname || grouping.ip_v4 || hasOwasp" class="host-sort-controls">
                                <span class="sort-label">Sort by:</span>
    
                                <ui-button
                                    label="Impact"
                                    :iconLeft="
                                        hostSort.field === 'impact'
                                        ? hostSort.dir === 'desc'
                                        ? 'fa-sort-amount-desc'
                                        : 'fa-sort-amount-asc'
                                        : 'fa-sort'
                                    "
                                    type="outline"
                                    :color="hostSort.field === 'impact' ? 'blue' : 'light-slate'"
                                    @click="setHostSort('impact')"
                                />
    
                                <ui-button
                                    label="Name"
                                    :iconLeft="
                                        hostSort.field === 'name'
                                        ? hostSort.dir === 'desc'
                                        ? 'fa-sort-alpha-desc'
                                        : 'fa-sort-alpha-asc'
                                        : 'fa-sort'
                                    "
                                    type="outline"
                                    :color="hostSort.field === 'name' ? 'blue' : 'light-slate'"
                                    @click="setHostSort('name')"
                                />
                            </div>
                            
<!--                            <div v-if="grouping.ungrouped" class="host-sort-controls">-->
<!--                                <span class="sort-label">Sort by:</span>-->
<!--    -->
<!--                                <ui-button-->
<!--                                    label="Impact"-->
<!--                                    :iconLeft="-->
<!--                                        ungroupedSort.field === 'impact'-->
<!--                                        ? ungroupedSort.dir === 'desc'-->
<!--                                        ? 'fa-sort-amount-desc'-->
<!--                                        : 'fa-sort-amount-asc'-->
<!--                                        : 'fa-sort'-->
<!--                                    "-->
<!--                                    type="outline"-->
<!--                                    :color="ungroupedSort.field === 'impact' ? 'blue' : 'light-slate'"-->
<!--                                    @click="setUngroupedSort('impact')"-->
<!--                                />-->
<!--    -->
<!--                                <ui-button-->
<!--                                    label="Last Detected"-->
<!--                                    :iconLeft="-->
<!--                                        ungroupedSort.field === 'last_detected_at'-->
<!--                                        ? ungroupedSort.dir === 'desc'-->
<!--                                        ? 'fa-sort-amount-desc'-->
<!--                                        : 'fa-sort-amount-asc'-->
<!--                                        : 'fa-sort'-->
<!--                                    "-->
<!--                                    type="outline"-->
<!--                                    :color="ungroupedSort.field === 'last_detected_at' ? 'blue' : 'light-slate'"-->
<!--                                    @click="setUngroupedSort('last_detected_at')"-->
<!--                                />-->
<!--    -->
<!--                                <ui-button-->
<!--                                    label="Title"-->
<!--                                    :iconLeft="-->
<!--                                        ungroupedSort.field === 'title'-->
<!--                                        ? ungroupedSort.dir === 'desc'-->
<!--                                        ? 'fa-sort-alpha-desc'-->
<!--                                        : 'fa-sort-alpha-asc'-->
<!--                                        : 'fa-sort'-->
<!--                                    "-->
<!--                                    type="outline"-->
<!--                                    :color="ungroupedSort.field === 'title' ? 'blue' : 'light-slate'"-->
<!--                                    @click="setUngroupedSort('title')"-->
<!--                                />-->
<!--                            </div>-->
                            
                            <div>
                                <ui-button
                                    label="Refresh"
                                    iconLeft="fa-refresh"
                                    type="outline"
                                    @click="refresh"
                                />
                            </div>
                        </div>
                    </template>
                    
<!--                    <div data-tab="Ungrouped" :data-count="filteredVulnCount">-->
<!--                        <div class="datatable treetable">-->
<!--                            <div class="tree">-->
<!--                                <div class="ungrouped-flat-table">-->
<!--                                    <apck-vuln-details-->
<!--                                        v-if="!loadingUngrouped"-->
<!--                                        :table="vuln_table"-->
<!--                                        title=""-->
<!--                                        :rows="ungroupedRows"-->
<!--                                        :showTitle="true"-->
<!--                                        @row-deleted="ungroupedRowDeleted($event)"-->
<!--                                    />-->
<!--                                    <div v-if="ungroupedRows.length === 0 && !loadingUngrouped" class="apck-center">-->
<!--                                        <apck-col-wrapper>-->
<!--                                            No row data to display-->
<!--                                        </apck-col-wrapper>-->
<!--                                    </div>-->
<!--                                    <apck-pagebar v-if="ungroupedStore" class="ungrouped-pagination" :store="ungroupedStore" />-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
    
                    <div data-tab="Group by Impact">
                        <div v-if="firstLoad" class="datatable treetable">
                            <div class="tree">
                                <ul>
                                    <apck-tree-impact-row
                                        v-if="query.inc_critical"
                                        ref="critical"
                                        level="critical"
                                        value="Critical"
                                        :countProp="impact.critical"
                                        :table="vuln_table"
                                        @impact-row-deleted="impactRowDeleted($event)"
                                    />
            
                                    <apck-tree-impact-row
                                        v-if="query.inc_high"
                                        ref="high"
                                        level="high"
                                        value="High"
                                        :countProp="impact.high"
                                        :table="vuln_table"
                                        @impact-row-deleted="impactRowDeleted($event)"
                                    />
            
                                    <apck-tree-impact-row
                                        v-if="query.inc_medium"
                                        level="medium"
                                        value="Medium"
                                        :countProp="impact.medium"
                                        :table="vuln_table"
                                        @impact-row-deleted="impactRowDeleted($event)"
                                    />
            
                                    <apck-tree-impact-row
                                        v-if="query.inc_low"
                                        level="low"
                                        value="Low"
                                        :countProp="impact.low"
                                        :table="vuln_table"
                                        @impact-row-deleted="impactRowDeleted($event)"
                                    />
            
                                    <apck-tree-impact-row
                                        v-if="query.inc_info"
                                        level="info"
                                        value="Info"
                                        :countProp="impact.info"
                                        :table="vuln_table"
                                        @impact-row-deleted="impactRowDeleted($event)"
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
    
                    <div data-tab="Group by Hostname" :data-count="Object.keys(hosts).length">
                        <div v-if="firstLoad" class="datatable treetable">
                            <div class="tree">
                                <ul>
                                    <apck-tree-host-row
                                        v-for="item in sortedHosts"
                                        :key="'host' + item.host + item.data.total"
                                        :value="item.host"
                                        :count-prop="item.data.total"
                                        :critical-prop="item.data.critical"
                                        :high-prop="item.data.high"
                                        :medium-prop="item.data.medium"
                                        :low-prop="item.data.low"
                                        :info-prop="item.data.info"
                                        :table="vuln_table"
                                        @host-row-deleted="hostRowDeleted($event)"
                                    />
            
                                    <li v-if="sortedHosts.length === 0" class="apck-center">
                                        <apck-col-wrapper>
                                            No row data to display
                                        </apck-col-wrapper>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
    
                    <div data-tab="Group by IPv4" :data-count="Object.keys(ipv4).length">
                        <div v-if="firstLoad" class="datatable treetable">
                            <div class="tree">
                                <ul>
                                    <apck-tree-host-row
                                        v-for="item in sortedIPv4"
                                        :key="'ipv4' + item.host + item.data.total"
                                        :value="item.host"
                                        :count-prop="item.data.total"
                                        :critical-prop="item.data.critical"
                                        :high-prop="item.data.high"
                                        :medium-prop="item.data.medium"
                                        :low-prop="item.data.low"
                                        :info-prop="item.data.info"
                                        :table="vuln_table"
                                        :is_ipv4="true"
                                        @host-row-deleted="hostRowDeleted($event)"
                                    />
            
                                    <li v-if="sortedIPv4.length === 0" class="apck-center">
                                        <apck-col-wrapper>
                                            No row data to display
                                        </apck-col-wrapper>
                                    </li>
                                </ul>

                                <ul v-if="!firstLoad">
                                    <li class="apck-center">
                                        <apck-col-wrapper>
                                            Loading row data
                                        </apck-col-wrapper>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        :data-tab="owaspTitle"
                        v-if="hasOwasp"
                        :data-count="Object.keys(owasp).length"
                    >
                        <div v-if="firstLoad" class="datatable treetable">
                            <div class="tree">
                                <ul>
                                    <apck-tree-owasp-row
                                        v-for="item in sortedOwasp"
                                        :key="'owasp-' + item.owaspName + item.data.total"
                                        :value="item.owaspName"
                                        :owasp-year="owaspYear"
                                        :count-prop="item.data.total"
                                        :critical-prop="item.data.critical"
                                        :high-prop="item.data.high"
                                        :medium-prop="item.data.medium"
                                        :low-prop="item.data.low"
                                        :info-prop="item.data.info"
                                        :table="vuln_table"
                                        @owasp-row-deleted="owaspRowDeleted($event)"
                                    />

                                    <li v-if="!hasOwasp" class="apck-center">
                                        <apck-col-wrapper>
                                            No row data to display
                                        </apck-col-wrapper>
                                    </li>
                                </ul>
                                <ul v-if="!firstLoad">
                                    <li class="apck-center">
                                        <apck-col-wrapper>
                                            Loading row data
                                        </apck-col-wrapper>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </ui-tabs>
                <apck-toolbar class="toolbar-bottom">
                    <apck-button
                        v-if="showImportButton && $permissions?.role_is_manager"
                        title="Import"
                        value="Import"
                        class="btn-neutral"
                        icon="fa-plus"
                        :handler="importVulns"
                    />
                </apck-toolbar>
            </ui-layout>
        </div>
    `
}
